(function (_, kotlin_kotlin, kotlin_org_kodein_type_kodein_type) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var classMeta = kotlin_kotlin.$_$.v8;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.h1;
  var first = kotlin_kotlin.$_$.d6;
  var Unit_getInstance = kotlin_kotlin.$_$.k4;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.y;
  var filterNotNull = kotlin_kotlin.$_$.a6;
  var sorted = kotlin_kotlin.$_$.d7;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.r1;
  var repeat = kotlin_kotlin.$_$.lb;
  var ensureNotNull = kotlin_kotlin.$_$.id;
  var KProperty1 = kotlin_kotlin.$_$.qa;
  var getPropertyCallableRef = kotlin_kotlin.$_$.b9;
  var toString = kotlin_kotlin.$_$.sd;
  var Companion_getInstance = kotlin_org_kodein_type_kodein_type.$_$.a;
  var equals = kotlin_kotlin.$_$.x8;
  var interfaceMeta = kotlin_kotlin.$_$.e9;
  var RuntimeException = kotlin_kotlin.$_$.uc;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.k2;
  var captureStack = kotlin_kotlin.$_$.p8;
  var hashCode = kotlin_kotlin.$_$.d9;
  var THROW_CCE = kotlin_kotlin.$_$.vc;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var objectMeta = kotlin_kotlin.$_$.y9;
  var TypeToken = kotlin_org_kodein_type_kodein_type.$_$.b;
  var isInterface = kotlin_kotlin.$_$.n9;
  var joinToString$default = kotlin_kotlin.$_$.k;
  var erasedOf = kotlin_org_kodein_type_kodein_type.$_$.c;
  var isObject = kotlin_kotlin.$_$.p9;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.x;
  var toString_0 = kotlin_kotlin.$_$.ca;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.e1;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.b1;
  var charSequenceLength = kotlin_kotlin.$_$.t8;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.e2;
  var Enum = kotlin_kotlin.$_$.lc;
  var Map = kotlin_kotlin.$_$.v4;
  var listOf = kotlin_kotlin.$_$.o6;
  var plus = kotlin_kotlin.$_$.v6;
  var emptyList = kotlin_kotlin.$_$.w5;
  var plus_0 = kotlin_kotlin.$_$.w6;
  var checkIndexOverflow = kotlin_kotlin.$_$.h5;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.t2;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.i5;
  var mapCapacity = kotlin_kotlin.$_$.q6;
  var coerceAtLeast = kotlin_kotlin.$_$.ea;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.g1;
  var to = kotlin_kotlin.$_$.td;
  var KProperty0 = kotlin_kotlin.$_$.pa;
  var KMutableProperty0 = kotlin_kotlin.$_$.na;
  var lazy = kotlin_kotlin.$_$.od;
  var asSequence = kotlin_kotlin.$_$.f5;
  var filter = kotlin_kotlin.$_$.sa;
  var flatMap = kotlin_kotlin.$_$.ta;
  var mapNotNull = kotlin_kotlin.$_$.ua;
  var map = kotlin_kotlin.$_$.va;
  var toList = kotlin_kotlin.$_$.wa;
  var Triple = kotlin_kotlin.$_$.xc;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.z;
  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.c1;
  var Collection = kotlin_kotlin.$_$.m4;
  var addAll = kotlin_kotlin.$_$.c5;
  var getOrNull = kotlin_kotlin.$_$.f6;
  //endregion
  //region block: pre-declaration
  DIDefinition.prototype = Object.create(DIDefining.prototype);
  DIDefinition.prototype.constructor = DIDefinition;
  DependencyLoopException.prototype = Object.create(RuntimeException.prototype);
  DependencyLoopException.prototype.constructor = DependencyLoopException;
  NotFoundException.prototype = Object.create(RuntimeException.prototype);
  NotFoundException.prototype.constructor = NotFoundException;
  OverridingException.prototype = Object.create(RuntimeException.prototype);
  OverridingException.prototype.constructor = OverridingException;
  function import$default(module_0, allowOverride, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      allowOverride = false;
    var tmp;
    if ($handler == null) {
      this.v4n(module_0, allowOverride);
      tmp = Unit_getInstance();
    } else {
      tmp = $handler(module_0, allowOverride);
    }
    return tmp;
  }
  function get_diContext() {
    return get_AnyDIContext();
  }
  function get_diTrigger() {
    return null;
  }
  function get_di() {
    return this;
  }
  function factory$default(key, context, overrideLevel, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      overrideLevel = 0;
    return $handler == null ? this.r4o(key, context, overrideLevel) : $handler(key, context, overrideLevel);
  }
  function provider(key, context, overrideLevel) {
    var tmp$ret$0;
    // Inline function 'org.kodein.di.toProvider' call
    var tmp0_toProvider = this.s4o(key, context, 0, 4, null);
    tmp$ret$0 = DIContainer$provider$lambda(tmp0_toProvider);
    return tmp$ret$0;
  }
  function provider$default(key, context, overrideLevel, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      overrideLevel = 0;
    return $handler == null ? this.t4o(key, context, overrideLevel) : $handler(key, context, overrideLevel);
  }
  function find$default(key, overrideLevel, all, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      overrideLevel = 0;
    if (!(($mask0 & 4) === 0))
      all = false;
    return $handler == null ? this.w4o(key, overrideLevel, all) : $handler(key, overrideLevel, all);
  }
  function get_di_0() {
    return this.a4p();
  }
  function factoryFullName() {
    return this.m4p();
  }
  function get_scope() {
    return null;
  }
  function get_description() {
    var arg = !equals(this.p4n(), Companion_getInstance().p4m_1) ? this.p4n().e4m() + ' -> ' : '';
    var tmp;
    var tmp_0 = this.l4n();
    if (tmp_0 instanceof NoScope) {
      tmp = null;
    } else {
      tmp = this.l4n();
    }
    var scope = tmp;
    var tmp0_safe_receiver = scope;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'org.kodein.di.bindings.DIBinding.<get-description>.<anonymous>' call
      tmp$ret$0 = 'scoped(' + erasedOf(tmp0_safe_receiver).e4m() + ').';
      tmp$ret$1 = tmp$ret$0;
      tmp_1 = tmp$ret$1;
    }
    var tmp1_elvis_lhs = tmp_1;
    var context = tmp1_elvis_lhs == null ? !equals(this.m4n(), Companion_getInstance().q4m_1) ? 'contexted<' + this.m4n().e4m() + '>().' : '' : tmp1_elvis_lhs;
    return context + this.m4p() + ' { ' + arg + this.o4p().e4m() + ' }';
  }
  function get_fullDescription() {
    var arg = !equals(this.p4n(), Companion_getInstance().p4m_1) ? this.p4n().g4m() + ' -> ' : '';
    var tmp;
    var tmp_0 = this.l4n();
    if (tmp_0 instanceof NoScope) {
      tmp = null;
    } else {
      tmp = this.l4n();
    }
    var scope = tmp;
    var tmp0_safe_receiver = scope;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'org.kodein.di.bindings.DIBinding.<get-fullDescription>.<anonymous>' call
      tmp$ret$0 = 'scoped(' + erasedOf(tmp0_safe_receiver).g4m() + ').';
      tmp$ret$1 = tmp$ret$0;
      tmp_1 = tmp$ret$1;
    }
    var tmp1_elvis_lhs = tmp_1;
    var context = tmp1_elvis_lhs == null ? !equals(this.m4n(), Companion_getInstance().q4m_1) ? 'contexted<' + this.m4n().g4m() + '>().' : '' : tmp1_elvis_lhs;
    return context + this.n4p() + ' { ' + arg + this.o4p().g4m() + ' }';
  }
  function get_supportSubTypes() {
    return false;
  }
  function get_argType() {
    return Companion_getInstance().p4m_1;
  }
  StandardScopeRegistry.prototype = Object.create(ScopeRegistry.prototype);
  StandardScopeRegistry.prototype.constructor = StandardScopeRegistry;
  DIMainBuilderImpl.prototype = Object.create(DIBuilderImpl.prototype);
  DIMainBuilderImpl.prototype.constructor = DIMainBuilderImpl;
  OverrideMode.prototype = Object.create(Enum.prototype);
  OverrideMode.prototype.constructor = OverrideMode;
  DIContainerBuilderImpl$OverrideMode$ALLOW_SILENT.prototype = Object.create(OverrideMode.prototype);
  DIContainerBuilderImpl$OverrideMode$ALLOW_SILENT.prototype.constructor = DIContainerBuilderImpl$OverrideMode$ALLOW_SILENT;
  DIContainerBuilderImpl$OverrideMode$ALLOW_EXPLICIT.prototype = Object.create(OverrideMode.prototype);
  DIContainerBuilderImpl$OverrideMode$ALLOW_EXPLICIT.prototype.constructor = DIContainerBuilderImpl$OverrideMode$ALLOW_EXPLICIT;
  DIContainerBuilderImpl$OverrideMode$FORBID.prototype = Object.create(OverrideMode.prototype);
  DIContainerBuilderImpl$OverrideMode$FORBID.prototype.constructor = DIContainerBuilderImpl$OverrideMode$FORBID;
  Down.prototype = Object.create(TypeChecker.prototype);
  Down.prototype.constructor = Down;
  Up.prototype = Object.create(TypeChecker.prototype);
  Up.prototype.constructor = Up;
  DirectDIImpl.prototype = Object.create(DirectDIBaseImpl.prototype);
  DirectDIImpl.prototype.constructor = DirectDIImpl;
  //endregion
  function DIDefinition(binding, fromModule, tree) {
    DIDefining.call(this, binding, fromModule);
    this.x4m_1 = tree;
  }
  DIDefinition.$metadata$ = classMeta('DIDefinition', undefined, undefined, undefined, undefined, DIDefining.prototype);
  function description(_this__u8e3s4, withOverrides, ident) {
    return descriptionImpl(_this__u8e3s4, withOverrides, ident, bindDescription$factory(), description$factory());
  }
  function description$default(_this__u8e3s4, withOverrides, ident, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      withOverrides = false;
    if (!(($mask0 & 2) === 0))
      ident = 8;
    return description(_this__u8e3s4, withOverrides, ident);
  }
  function DIDefining(binding, fromModule) {
    this.y4m_1 = binding;
    this.z4m_1 = fromModule;
  }
  DIDefining.prototype.a4n = function () {
    return this.y4m_1;
  };
  DIDefining.prototype.b4n = function () {
    return this.z4m_1;
  };
  DIDefining.$metadata$ = classMeta('DIDefining');
  function descriptionImpl(_this__u8e3s4, withOverrides, ident, keyBindDisp, bindingDisp) {
    var tmp$ret$4;
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0_groupBy = _this__u8e3s4.v();
    var tmp$ret$3;
    // Inline function 'kotlin.collections.groupByTo' call
    var tmp0_groupByTo = LinkedHashMap_init_$Create$();
    var tmp0_iterator = tmp0_groupBy.d();
    while (tmp0_iterator.e()) {
      var element = tmp0_iterator.f();
      var tmp$ret$0;
      // Inline function 'org.kodein.di.descriptionImpl.<anonymous>' call
      tmp$ret$0 = first(element.x()).z4m_1;
      var key = tmp$ret$0;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = tmp0_groupByTo.p(key);
      var tmp;
      if (value == null) {
        var tmp$ret$1;
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        tmp$ret$1 = ArrayList_init_$Create$();
        var answer = tmp$ret$1;
        tmp0_groupByTo.a(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      tmp$ret$2 = tmp;
      var list = tmp$ret$2;
      list.b(element);
    }
    tmp$ret$3 = tmp0_groupByTo;
    tmp$ret$4 = tmp$ret$3;
    var byModule = tmp$ret$4;
    var modules = sorted(filterNotNull(byModule.m2()));
    var tmp$ret$7;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$6;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.kodein.di.descriptionImpl.<anonymous>' call
    var tmp0_safe_receiver = byModule.p(null);
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$5;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      descriptionImpl$appendBindings(tmp0_apply, keyBindDisp, bindingDisp, withOverrides, ident, tmp0_safe_receiver);
      tmp$ret$5 = Unit_getInstance();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = modules.d();
    while (tmp0_iterator_0.e()) {
      var element_0 = tmp0_iterator_0.f();
      // Inline function 'org.kodein.di.descriptionImpl.<anonymous>.<anonymous>' call
      tmp0_apply.r6(repeat(' ', ident) + 'module ' + element_0 + ' {\n');
      descriptionImpl$appendBindings(tmp0_apply, keyBindDisp, bindingDisp, withOverrides, ident + 4 | 0, ensureNotNull(byModule.p(element_0)));
      tmp0_apply.r6(repeat(' ', ident) + '}\n');
    }
    tmp$ret$6 = tmp0_apply;
    tmp$ret$7 = tmp$ret$6.toString();
    return tmp$ret$7;
  }
  function fullDescription(_this__u8e3s4, withOverrides, ident) {
    return descriptionImpl(_this__u8e3s4, withOverrides, ident, bindFullDescription$factory(), fullDescription$factory());
  }
  function fullDescription$default(_this__u8e3s4, withOverrides, ident, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      withOverrides = false;
    if (!(($mask0 & 2) === 0))
      ident = 8;
    return fullDescription(_this__u8e3s4, withOverrides, ident);
  }
  function descriptionImpl$appendBindings(_this__u8e3s4, $keyBindDisp, $bindingDisp, $withOverrides, ident, entries) {
    var tmp0_iterator = entries.d();
    while (tmp0_iterator.e()) {
      var element = tmp0_iterator.f();
      // Inline function 'org.kodein.di.descriptionImpl.appendBindings.<anonymous>' call
      var keyDescription = $keyBindDisp(element.w());
      _this__u8e3s4.r6(repeat(' ', ident) + keyDescription + ' { ' + $bindingDisp(first(element.x()).y4m_1) + ' }');
      if ($withOverrides) {
        var subIdent = keyDescription.length - 4 | 0;
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_forEach = element.x().t2(1, element.x().g());
        var tmp0_iterator_0 = tmp0_forEach.d();
        while (tmp0_iterator_0.e()) {
          var element_0 = tmp0_iterator_0.f();
          // Inline function 'org.kodein.di.descriptionImpl.appendBindings.<anonymous>.<anonymous>' call
          _this__u8e3s4.r6(repeat(' ', subIdent) + 'overrides ' + $bindingDisp(element_0.y4m_1));
        }
      }
      _this__u8e3s4.r6('\n');
    }
    return Unit_getInstance();
  }
  function bindDescription$factory() {
    return getPropertyCallableRef('bindDescription', 1, KProperty1, function (receiver) {
      return receiver.h4n();
    }, null);
  }
  function description$factory() {
    return getPropertyCallableRef('description', 1, KProperty1, function (receiver) {
      return receiver.i4n();
    }, null);
  }
  function bindFullDescription$factory() {
    return getPropertyCallableRef('bindFullDescription', 1, KProperty1, function (receiver) {
      return receiver.j4n();
    }, null);
  }
  function fullDescription$factory() {
    return getPropertyCallableRef('fullDescription', 1, KProperty1, function (receiver) {
      return receiver.k4n();
    }, null);
  }
  function appendDescription(_this__u8e3s4, $this, displayString) {
    if (!($this.f4n_1 == null)) {
      _this__u8e3s4.r6(' tagged "' + toString($this.f4n_1) + '"');
    }
    if (!equals($this.c4n_1, Companion_getInstance().q4m_1)) {
      _this__u8e3s4.r6(' on context ' + displayString($this.c4n_1));
    }
    if (!equals($this.d4n_1, Companion_getInstance().p4m_1)) {
      _this__u8e3s4.r6(', with argument ' + displayString($this.d4n_1));
    }
  }
  function TypeToken$simpleDispString$ref() {
    var l = function (p0) {
      return p0.e4m();
    };
    l.callableName = 'simpleDispString';
    return l;
  }
  function TypeToken$qualifiedDispString$ref() {
    var l = function (p0) {
      return p0.g4m();
    };
    l.callableName = 'qualifiedDispString';
    return l;
  }
  function WithScope() {
  }
  WithScope.$metadata$ = interfaceMeta('WithScope', [BindBuilder]);
  function Module_init_$Init$(name, allowSilentOverride, prefix, init, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      allowSilentOverride = false;
    if (!(($mask0 & 4) === 0))
      prefix = '';
    Module.call($this, name, allowSilentOverride, prefix, init);
    return $this;
  }
  function Module_init_$Create$(name, allowSilentOverride, prefix, init, $mask0, $marker) {
    return Module_init_$Init$(name, allowSilentOverride, prefix, init, $mask0, $marker, Object.create(Module.prototype));
  }
  function DI$Companion$lazy$lambda($allowSilentOverride, $init) {
    return function () {
      return DIImpl_init_$Create$($allowSilentOverride, $init);
    };
  }
  function DependencyLoopException(message) {
    RuntimeException_init_$Init$(message, this);
    captureStack(this, DependencyLoopException);
  }
  DependencyLoopException.$metadata$ = classMeta('DependencyLoopException', undefined, undefined, undefined, undefined, RuntimeException.prototype);
  function NotFoundException(key, message) {
    RuntimeException_init_$Init$(message, this);
    this.o4n_1 = key;
    captureStack(this, NotFoundException);
  }
  NotFoundException.$metadata$ = classMeta('NotFoundException', undefined, undefined, undefined, undefined, RuntimeException.prototype);
  function OverridingException(message) {
    RuntimeException_init_$Init$(message, this);
    captureStack(this, OverridingException);
  }
  OverridingException.$metadata$ = classMeta('OverridingException', undefined, undefined, undefined, undefined, RuntimeException.prototype);
  function Key(contextType, argType, type, tag) {
    this.c4n_1 = contextType;
    this.d4n_1 = argType;
    this.e4n_1 = type;
    this.f4n_1 = tag;
    this.g4n_1 = 0;
  }
  Key.prototype.m4n = function () {
    return this.c4n_1;
  };
  Key.prototype.p4n = function () {
    return this.d4n_1;
  };
  Key.prototype.o6 = function () {
    return this.e4n_1;
  };
  Key.prototype.q4n = function () {
    return this.f4n_1;
  };
  Key.prototype.hashCode = function () {
    if (this.g4n_1 === 0) {
      this.g4n_1 = hashCode(this.c4n_1);
      this.g4n_1 = imul(31, this.g4n_1) + hashCode(this.d4n_1) | 0;
      this.g4n_1 = imul(29, hashCode(this.e4n_1));
      var tmp = this;
      var tmp_0 = imul(23, this.g4n_1);
      var tmp0_safe_receiver = this.f4n_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      tmp.g4n_1 = tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    return this.g4n_1;
  };
  Key.prototype.toString = function () {
    return this.i4n();
  };
  Key.prototype.h4n = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.kodein.di.Key.<get-bindDescription>.<anonymous>' call
    tmp0_apply.r6('bind<' + this.e4n_1.e4m() + '>');
    if (!(this.f4n_1 == null)) {
      tmp0_apply.r6('(tag = "' + toString(this.f4n_1) + '")');
    }
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  Key.prototype.j4n = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.kodein.di.Key.<get-bindFullDescription>.<anonymous>' call
    tmp0_apply.r6('bind<' + this.e4n_1.g4m() + '>');
    if (!(this.f4n_1 == null)) {
      tmp0_apply.r6('(tag = "' + toString(this.f4n_1) + '")');
    }
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  Key.prototype.i4n = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.kodein.di.Key.<get-description>.<anonymous>' call
    tmp0_apply.r6(this.e4n_1.e4m());
    appendDescription(tmp0_apply, this, TypeToken$simpleDispString$ref());
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  Key.prototype.r4n = function () {
    return '(context: ' + this.c4n_1.e4m() + ', arg: ' + this.d4n_1.e4m() + ', type: ' + this.e4n_1.e4m() + ', tag: ' + toString(this.f4n_1) + ')';
  };
  Key.prototype.k4n = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.kodein.di.Key.<get-fullDescription>.<anonymous>' call
    tmp0_apply.r6(this.e4n_1.g4m());
    appendDescription(tmp0_apply, this, TypeToken$qualifiedDispString$ref());
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  Key.prototype.s4n = function (contextType, argType, type, tag) {
    return new Key(contextType, argType, type, tag);
  };
  Key.prototype.t4n = function (contextType, argType, type, tag, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      contextType = this.c4n_1;
    if (!(($mask0 & 2) === 0))
      argType = this.d4n_1;
    if (!(($mask0 & 4) === 0))
      type = this.e4n_1;
    if (!(($mask0 & 8) === 0))
      tag = this.f4n_1;
    return this.s4n(contextType, argType, type, tag);
  };
  Key.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Key))
      return false;
    var tmp0_other_with_cast = other instanceof Key ? other : THROW_CCE();
    if (!equals(this.c4n_1, tmp0_other_with_cast.c4n_1))
      return false;
    if (!equals(this.d4n_1, tmp0_other_with_cast.d4n_1))
      return false;
    if (!equals(this.e4n_1, tmp0_other_with_cast.e4n_1))
      return false;
    if (!equals(this.f4n_1, tmp0_other_with_cast.f4n_1))
      return false;
    return true;
  };
  Key.$metadata$ = classMeta('Key');
  function BindBuilder() {
  }
  BindBuilder.$metadata$ = interfaceMeta('BindBuilder');
  function Builder() {
  }
  Builder.$metadata$ = interfaceMeta('Builder', [BindBuilder, WithScope]);
  function MainBuilder() {
  }
  MainBuilder.$metadata$ = interfaceMeta('MainBuilder', [Builder]);
  function Module(name, allowSilentOverride, prefix, init) {
    this.x4n_1 = name;
    this.y4n_1 = allowSilentOverride;
    this.z4n_1 = prefix;
    this.a4o_1 = init;
  }
  Module.prototype.toString = function () {
    return 'Module(name=' + this.x4n_1 + ', allowSilentOverride=' + this.y4n_1 + ', prefix=' + this.z4n_1 + ', init=' + this.a4o_1 + ')';
  };
  Module.prototype.hashCode = function () {
    var result = getStringHashCode(this.x4n_1);
    result = imul(result, 31) + (this.y4n_1 | 0) | 0;
    result = imul(result, 31) + getStringHashCode(this.z4n_1) | 0;
    result = imul(result, 31) + hashCode(this.a4o_1) | 0;
    return result;
  };
  Module.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Module))
      return false;
    var tmp0_other_with_cast = other instanceof Module ? other : THROW_CCE();
    if (!(this.x4n_1 === tmp0_other_with_cast.x4n_1))
      return false;
    if (!(this.y4n_1 === tmp0_other_with_cast.y4n_1))
      return false;
    if (!(this.z4n_1 === tmp0_other_with_cast.z4n_1))
      return false;
    if (!equals(this.a4o_1, tmp0_other_with_cast.a4o_1))
      return false;
    return true;
  };
  Module.$metadata$ = classMeta('Module');
  function Companion() {
    Companion_instance = this;
    this.b4o_1 = false;
    this.c4o_1 = false;
  }
  Companion.prototype.d4o = function (allowSilentOverride, init) {
    return new LazyDI(DI$Companion$lazy$lambda(allowSilentOverride, init));
  };
  Companion.prototype.e4o = function (allowSilentOverride, init, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      allowSilentOverride = false;
    return this.d4o(allowSilentOverride, init);
  };
  Companion.$metadata$ = objectMeta('Companion');
  var Companion_instance;
  function Companion_getInstance_0() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function DI() {
  }
  DI.$metadata$ = interfaceMeta('DI', [DIAware]);
  function DIAware() {
  }
  DIAware.$metadata$ = interfaceMeta('DIAware');
  function Value(type, value) {
    this.j4o_1 = type;
    this.k4o_1 = value;
  }
  Value.prototype.o6 = function () {
    return this.j4o_1;
  };
  Value.prototype.x = function () {
    return this.k4o_1;
  };
  Value.prototype.toString = function () {
    return 'Value(type=' + this.j4o_1 + ', value=' + this.k4o_1 + ')';
  };
  Value.prototype.hashCode = function () {
    var result = hashCode(this.j4o_1);
    result = imul(result, 31) + hashCode(this.k4o_1) | 0;
    return result;
  };
  Value.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Value))
      return false;
    var tmp0_other_with_cast = other instanceof Value ? other : THROW_CCE();
    if (!equals(this.j4o_1, tmp0_other_with_cast.j4o_1))
      return false;
    if (!equals(this.k4o_1, tmp0_other_with_cast.k4o_1))
      return false;
    return true;
  };
  Value.$metadata$ = classMeta('Value', [DIContext]);
  function Companion_0() {
    Companion_instance_0 = this;
  }
  Companion_0.prototype.l4o = function (type, value) {
    return new Value(type, value);
  };
  Companion_0.$metadata$ = objectMeta('Companion');
  var Companion_instance_0;
  function Companion_getInstance_1() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function DIContext() {
  }
  DIContext.$metadata$ = interfaceMeta('DIContext');
  function get_AnyDIContext() {
    return Contexes_getInstance().m4o_1;
  }
  function Contexes() {
    Contexes_instance = this;
    this.m4o_1 = Companion_getInstance_1().l4o(Companion_getInstance().q4m_1, new Object());
  }
  Contexes.$metadata$ = objectMeta('Contexes');
  var Contexes_instance;
  function Contexes_getInstance() {
    if (Contexes_instance == null)
      new Contexes();
    return Contexes_instance;
  }
  function Instance(_this__u8e3s4, type, tag) {
    var tmp = _this__u8e3s4.i4o();
    var tmp_0 = _this__u8e3s4.h4o();
    return new DIProperty(tmp, tmp_0, Instance$lambda(_this__u8e3s4, type, tag));
  }
  function get_anyType(_this__u8e3s4) {
    var tmp = _this__u8e3s4.o6();
    return isInterface(tmp, TypeToken) ? tmp : THROW_CCE();
  }
  function On(_this__u8e3s4, context, trigger) {
    return DIWrapper_init_$Create$(_this__u8e3s4, context, trigger);
  }
  function On$default(_this__u8e3s4, context, trigger, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      context = _this__u8e3s4.h4o();
    if (!(($mask0 & 2) === 0))
      trigger = _this__u8e3s4.i4o();
    return On(_this__u8e3s4, context, trigger);
  }
  function DIWrapper_init_$Init$(base, diContext, trigger, $this) {
    DIWrapper.call($this, base.f4o(), diContext, trigger);
    return $this;
  }
  function DIWrapper_init_$Create$(base, diContext, trigger) {
    return DIWrapper_init_$Init$(base, diContext, trigger, Object.create(DIWrapper.prototype));
  }
  function DIWrapper(_base, diContext, diTrigger) {
    this.n4o_1 = _base;
    this.o4o_1 = diContext;
    this.p4o_1 = diTrigger;
  }
  DIWrapper.prototype.h4o = function () {
    return this.o4o_1;
  };
  DIWrapper.prototype.i4o = function () {
    return this.p4o_1;
  };
  DIWrapper.prototype.f4o = function () {
    return this;
  };
  DIWrapper.prototype.g4o = function () {
    return this.n4o_1.g4o();
  };
  DIWrapper.$metadata$ = classMeta('DIWrapper', [DI]);
  function Instance$lambda($this_Instance, $type, $tag) {
    return function (ctx, _anonymous_parameter_1__qggqgd) {
      var tmp = $this_Instance.f4o().g4o();
      var tmp$ret$0;
      // Inline function 'org.kodein.di.anyType' call
      var tmp_0 = ctx.o6();
      tmp$ret$0 = isInterface(tmp_0, TypeToken) ? tmp_0 : THROW_CCE();
      var tmp_1 = new Key(tmp$ret$0, Companion_getInstance().p4m_1, $type, $tag);
      var tmp_2 = ctx.x();
      return tmp.q4o(tmp_1, tmp_2, 0, 4, null)();
    };
  }
  function Builder_0() {
  }
  Builder_0.$metadata$ = interfaceMeta('Builder');
  function DIContainer$provider$lambda($tmp0_toProvider) {
    return function () {
      return $tmp0_toProvider(Unit_getInstance());
    };
  }
  function DIContainer() {
  }
  DIContainer.$metadata$ = interfaceMeta('DIContainer');
  function DITree() {
  }
  DITree.$metadata$ = interfaceMeta('DITree');
  function DirectDIBase() {
  }
  DirectDIBase.$metadata$ = interfaceMeta('DirectDIBase', [DirectDIAware]);
  function DirectDIAware() {
  }
  DirectDIAware.$metadata$ = interfaceMeta('DirectDIAware');
  function SearchSpecs_init_$Init$(contextType, argType, type, tag, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      contextType = null;
    if (!(($mask0 & 2) === 0))
      argType = null;
    if (!(($mask0 & 4) === 0))
      type = null;
    if (!(($mask0 & 8) === 0))
      tag = NoDefinedTag_getInstance();
    SearchSpecs.call($this, contextType, argType, type, tag);
    return $this;
  }
  function SearchSpecs_init_$Create$(contextType, argType, type, tag, $mask0, $marker) {
    return SearchSpecs_init_$Init$(contextType, argType, type, tag, $mask0, $marker, Object.create(SearchSpecs.prototype));
  }
  function NoDefinedTag() {
    NoDefinedTag_instance = this;
  }
  NoDefinedTag.$metadata$ = objectMeta('NoDefinedTag');
  var NoDefinedTag_instance;
  function NoDefinedTag_getInstance() {
    if (NoDefinedTag_instance == null)
      new NoDefinedTag();
    return NoDefinedTag_instance;
  }
  function SearchSpecs(contextType, argType, type, tag) {
    this.c4p_1 = contextType;
    this.d4p_1 = argType;
    this.e4p_1 = type;
    this.f4p_1 = tag;
  }
  SearchSpecs.prototype.toString = function () {
    var args = ArrayList_init_$Create$();
    if (!(this.c4p_1 == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp0_safe_receiver = this.c4p_1;
      var tmp0_plusAssign = 'contextType=' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e4m());
      args.b(tmp0_plusAssign);
    }
    if (!(this.d4p_1 == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp1_safe_receiver = this.d4p_1;
      var tmp1_plusAssign = 'argType=' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e4m());
      args.b(tmp1_plusAssign);
    }
    if (!(this.e4p_1 == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp2_safe_receiver = this.e4p_1;
      var tmp2_plusAssign = 'type=' + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.e4m());
      args.b(tmp2_plusAssign);
    }
    if (!equals(this.f4p_1, NoDefinedTag_getInstance())) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp3_plusAssign = 'tag=' + toString(this.f4p_1);
      args.b(tmp3_plusAssign);
    }
    return '[' + joinToString$default(args, ', ', null, null, 0, null, null, 62, null) + ']';
  };
  SearchSpecs.$metadata$ = classMeta('SearchSpecs');
  function NoArgBindingDI() {
  }
  NoArgBindingDI.$metadata$ = interfaceMeta('NoArgBindingDI', [DirectDI, WithContext]);
  function BindingDI() {
  }
  BindingDI.$metadata$ = interfaceMeta('BindingDI', [DirectDI, WithContext]);
  function NoArgBindingDIWrap(_di) {
    this.j4p_1 = _di;
  }
  NoArgBindingDIWrap.prototype.f4o = function () {
    return this.j4p_1.f4o();
  };
  NoArgBindingDIWrap.prototype.b4p = function () {
    return this.j4p_1.b4p();
  };
  NoArgBindingDIWrap.prototype.a4p = function () {
    return this.j4p_1.a4p();
  };
  NoArgBindingDIWrap.prototype.i4p = function (type, tag) {
    return this.j4p_1.i4p(type, tag);
  };
  NoArgBindingDIWrap.prototype.h4p = function (context) {
    return this.j4p_1.h4p(context);
  };
  NoArgBindingDIWrap.$metadata$ = classMeta('NoArgBindingDIWrap', [NoArgBindingDI, DirectDI, WithContext]);
  function WithContext() {
  }
  WithContext.$metadata$ = interfaceMeta('WithContext');
  function ErasedContext() {
    ErasedContext_instance = this;
  }
  ErasedContext.prototype.o6 = function () {
    return Companion_getInstance().q4m_1;
  };
  ErasedContext.prototype.x = function () {
    return ErasedContext_getInstance();
  };
  ErasedContext.$metadata$ = objectMeta('ErasedContext', [DIContext]);
  var ErasedContext_instance;
  function ErasedContext_getInstance() {
    if (ErasedContext_instance == null)
      new ErasedContext();
    return ErasedContext_instance;
  }
  function DIBinding$Copier$Companion$invoke$1($f) {
    this.k4p_1 = $f;
  }
  DIBinding$Copier$Companion$invoke$1.$metadata$ = classMeta(undefined, [Copier]);
  function Companion_1() {
    Companion_instance_1 = this;
  }
  Companion_1.prototype.l4p = function (f) {
    return new DIBinding$Copier$Companion$invoke$1(f);
  };
  Companion_1.$metadata$ = objectMeta('Companion');
  var Companion_instance_1;
  function Companion_getInstance_2() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function Copier() {
  }
  Copier.$metadata$ = interfaceMeta('Copier');
  function DIBinding() {
  }
  DIBinding.$metadata$ = interfaceMeta('DIBinding', [Binding]);
  function Binding() {
  }
  Binding.$metadata$ = interfaceMeta('Binding');
  function NoArgDIBinding() {
  }
  NoArgDIBinding.$metadata$ = interfaceMeta('NoArgDIBinding', [DIBinding]);
  function RefMaker() {
  }
  RefMaker.$metadata$ = interfaceMeta('RefMaker');
  function Reference(current, next) {
    this.s4p_1 = current;
    this.t4p_1 = next;
  }
  Reference.prototype.k3 = function () {
    return this.s4p_1;
  };
  Reference.prototype.l3 = function () {
    return this.t4p_1;
  };
  Reference.prototype.toString = function () {
    return 'Reference(current=' + this.s4p_1 + ', next=' + this.t4p_1 + ')';
  };
  Reference.prototype.hashCode = function () {
    var result = hashCode(this.s4p_1);
    result = imul(result, 31) + hashCode(this.t4p_1) | 0;
    return result;
  };
  Reference.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Reference))
      return false;
    var tmp0_other_with_cast = other instanceof Reference ? other : THROW_CCE();
    if (!equals(this.s4p_1, tmp0_other_with_cast.s4p_1))
      return false;
    if (!equals(this.t4p_1, tmp0_other_with_cast.t4p_1))
      return false;
    return true;
  };
  Reference.$metadata$ = classMeta('Reference');
  function SingletonReference$make$lambda($value) {
    return function () {
      return $value;
    };
  }
  function SingletonReference() {
    SingletonReference_instance = this;
  }
  SingletonReference.prototype.r4p = function (creator) {
    var value = creator();
    return new Reference(value, SingletonReference$make$lambda(value));
  };
  SingletonReference.$metadata$ = objectMeta('SingletonReference', [RefMaker]);
  var SingletonReference_instance;
  function SingletonReference_getInstance() {
    if (SingletonReference_instance == null)
      new SingletonReference();
    return SingletonReference_instance;
  }
  function Scope() {
  }
  Scope.$metadata$ = interfaceMeta('Scope');
  function ContextTranslator() {
  }
  ContextTranslator.$metadata$ = interfaceMeta('ContextTranslator');
  function ScopeRegistry() {
  }
  ScopeRegistry.$metadata$ = classMeta('ScopeRegistry', [ScopeCloseable]);
  function ScopeCloseable() {
  }
  ScopeCloseable.$metadata$ = interfaceMeta('ScopeCloseable');
  function NoScope() {
    this.y4p_1 = new StandardScopeRegistry();
  }
  NoScope.prototype.z4p = function (context) {
    return this.y4p_1;
  };
  NoScope.prototype.u4p = function (context) {
    return this.z4p((context == null ? true : isObject(context)) ? context : THROW_CCE());
  };
  NoScope.$metadata$ = classMeta('NoScope', [Scope]);
  function StandardScopeRegistry() {
    ScopeRegistry.call(this);
    this.a4q_1 = newConcurrentMap();
    this.b4q_1 = new Object();
  }
  StandardScopeRegistry.prototype.x4p = function (key, sync, creator) {
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'org.kodein.di.internal.synchronizedIfNull' call
      var tmp0_synchronizedIfNull = sync ? this.b4q_1 : null;
      var tmp$ret$0;
      // Inline function 'org.kodein.di.bindings.StandardScopeRegistry.getOrCreate.<anonymous>' call
      var tmp0_safe_receiver = this.a4q_1.p(key);
      tmp$ret$0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
      var tmp0_safe_receiver_0 = tmp$ret$0;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        var tmp$ret$3;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$1;
        // Inline function 'org.kodein.di.bindings.StandardScopeRegistry.getOrCreate.<anonymous>' call
        tmp$ret$1 = tmp0_safe_receiver_0;
        tmp$ret$2 = tmp$ret$1;
        break $l$block_1;
      }
      var tmp$ret$8;
      // Inline function 'org.kodein.di.internal.maySynchronized' call
      var tmp$ret$5;
      $l$block_0: {
        // Inline function 'org.kodein.di.internal.synchronizedIfNull.<anonymous>' call
        var tmp$ret$4;
        // Inline function 'org.kodein.di.bindings.StandardScopeRegistry.getOrCreate.<anonymous>' call
        var tmp0_safe_receiver_1 = this.a4q_1.p(key);
        tmp$ret$4 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1();
        var tmp0_safe_receiver_2 = tmp$ret$4;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          var tmp$ret$6;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          tmp$ret$5 = tmp0_safe_receiver_2;
          break $l$block_0;
        }
        var tmp$ret$7;
        // Inline function 'org.kodein.di.bindings.StandardScopeRegistry.getOrCreate.<anonymous>' call
        var tmp0_container = creator();
        var current = tmp0_container.k3();
        var next = tmp0_container.l3();
        // Inline function 'kotlin.collections.set' call
        var tmp0_set = this.a4q_1;
        tmp0_set.a(key, next);
        tmp$ret$7 = current;
        tmp$ret$2 = tmp$ret$7;
        break $l$block_1;
      }
      tmp$ret$8 = tmp$ret$5;
      var value = tmp$ret$8;
      var tmp$ret$9;
      // Inline function 'org.kodein.di.bindings.StandardScopeRegistry.getOrCreate.<anonymous>' call
      tmp$ret$9 = value;
      tmp$ret$2 = tmp$ret$9;
    }
    return tmp$ret$2;
  };
  StandardScopeRegistry.$metadata$ = classMeta('StandardScopeRegistry', undefined, undefined, undefined, undefined, ScopeRegistry.prototype);
  function toKContext(_this__u8e3s4, di, ctx) {
    var tmp0_safe_receiver = _this__u8e3s4.w4p(di, ctx);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'org.kodein.di.bindings.toKContext.<anonymous>' call
      tmp$ret$0 = Companion_getInstance_1().l4o(_this__u8e3s4.v4p(), tmp0_safe_receiver);
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    return tmp;
  }
  function CompositeContextTranslator(src, dst) {
    this.c4q_1 = src;
    this.d4q_1 = dst;
  }
  CompositeContextTranslator.prototype.e4q = function () {
    return this.d4q_1;
  };
  CompositeContextTranslator.prototype.m4n = function () {
    return this.c4q_1.m4n();
  };
  CompositeContextTranslator.prototype.v4p = function () {
    return this.d4q_1.v4p();
  };
  CompositeContextTranslator.prototype.w4p = function (di, ctx) {
    var tmp0_safe_receiver = this.c4q_1.w4p(di, ctx);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'org.kodein.di.bindings.CompositeContextTranslator.translate.<anonymous>' call
      tmp$ret$0 = this.d4q_1.w4p(di, tmp0_safe_receiver);
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    return tmp;
  };
  CompositeContextTranslator.prototype.toString = function () {
    return '(' + this.c4q_1 + ' -> ' + this.d4q_1 + ')';
  };
  CompositeContextTranslator.$metadata$ = classMeta('CompositeContextTranslator', [ContextTranslator]);
  function factoryName($this, params) {
    var tmp$ret$2;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.kodein.di.bindings.Singleton.factoryName.<anonymous>' call
    tmp0_apply.r6('singleton');
    var tmp$ret$0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp$ret$0 = !params.m();
    if (tmp$ret$0) {
      tmp0_apply.r6(joinToString$default(params, ', ', '(', ')', 0, null, null, 56, null));
    }
    tmp$ret$1 = tmp0_apply;
    tmp$ret$2 = tmp$ret$1.toString();
    return tmp$ret$2;
  }
  function Singleton$getFactory$lambda$lambda$lambda(this$0, $bindingDi) {
    return function () {
      return this$0.k4q_1(new NoArgBindingDIWrap($bindingDi));
    };
  }
  function Singleton$getFactory$lambda$lambda(this$0, $bindingDi) {
    return function () {
      return this$0.l4q_1.r4p(Singleton$getFactory$lambda$lambda$lambda(this$0, $bindingDi));
    };
  }
  function Singleton$getFactory$lambda($lateInitRegistry, this$0, $bindingDi) {
    return function (_anonymous_parameter_0__qggqh8) {
      var tmp0_elvis_lhs = $lateInitRegistry._v;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp$ret$0;
        // Inline function 'kotlin.also' call
        var tmp0_also = this$0.f4q_1.u4p($bindingDi.m4());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'org.kodein.di.bindings.Singleton.getFactory.<anonymous>.<anonymous>' call
        $lateInitRegistry._v = tmp0_also;
        tmp$ret$0 = tmp0_also;
        tmp = tmp$ret$0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var registry = tmp;
      var tmp_0 = registry.x4p(this$0.m4q_1, this$0.j4q_1, Singleton$getFactory$lambda$lambda(this$0, $bindingDi));
      return isObject(tmp_0) ? tmp_0 : THROW_CCE();
    };
  }
  function Singleton$copier$lambda(this$0) {
    return function (it) {
      return new Singleton(this$0.f4q_1, this$0.g4q_1, this$0.h4q_1, this$0.i4q_1, this$0.l4q_1, this$0.j4q_1, this$0.k4q_1);
    };
  }
  function Singleton(scope, contextType, explicitContext, createdType, refMaker, sync, creator) {
    this.f4q_1 = scope;
    this.g4q_1 = contextType;
    this.h4q_1 = explicitContext;
    this.i4q_1 = createdType;
    this.j4q_1 = sync;
    this.k4q_1 = creator;
    var tmp = this;
    var tmp0_elvis_lhs = refMaker;
    tmp.l4q_1 = tmp0_elvis_lhs == null ? SingletonReference_getInstance() : tmp0_elvis_lhs;
    this.m4q_1 = new ScopeKey(new Object(), Unit_getInstance());
    var tmp_0 = this;
    var tmp_1 = Companion_getInstance_2();
    tmp_0.n4q_1 = tmp_1.l4p(Singleton$copier$lambda(this));
  }
  Singleton.prototype.l4n = function () {
    return this.f4q_1;
  };
  Singleton.prototype.m4n = function () {
    return this.g4q_1;
  };
  Singleton.prototype.o4p = function () {
    return this.i4q_1;
  };
  Singleton.prototype.m4p = function () {
    var params = ArrayList_init_$Create$_0(2);
    if (!equals(this.l4q_1, SingletonReference_getInstance())) {
      params.b('ref = ' + erasedOf(this.l4q_1).e4m());
    }
    return factoryName(this, params);
  };
  Singleton.prototype.n4p = function () {
    var params = ArrayList_init_$Create$_0(2);
    if (!equals(this.l4q_1, SingletonReference_getInstance())) {
      params.b('ref = ' + erasedOf(this.l4q_1).g4m());
    }
    return factoryName(this, params);
  };
  Singleton.prototype.o4q = function (key, di) {
    var lateInitRegistry = {_v: null};
    var bindingDi = this.h4q_1 ? di : di.g4p();
    return Singleton$getFactory$lambda(lateInitRegistry, this, bindingDi);
  };
  Singleton.prototype.q4p = function (key, di) {
    return this.o4q(key, di);
  };
  Singleton.$metadata$ = classMeta('Singleton', [NoArgDIBinding]);
  function Provider$getFactory$lambda(this$0, $di) {
    return function (_anonymous_parameter_0__qggqh8) {
      return this$0.r4q_1(new NoArgBindingDIWrap($di));
    };
  }
  function Provider(contextType, createdType, creator) {
    this.p4q_1 = contextType;
    this.q4q_1 = createdType;
    this.r4q_1 = creator;
  }
  Provider.prototype.m4n = function () {
    return this.p4q_1;
  };
  Provider.prototype.o4p = function () {
    return this.q4q_1;
  };
  Provider.prototype.m4p = function () {
    return 'provider';
  };
  Provider.prototype.o4q = function (key, di) {
    return Provider$getFactory$lambda(this, di);
  };
  Provider.prototype.q4p = function (key, di) {
    return this.o4q(key, di);
  };
  Provider.$metadata$ = classMeta('Provider', [NoArgDIBinding]);
  function ScopeKey(scopeId, arg) {
    this.s4q_1 = scopeId;
    this.t4q_1 = arg;
  }
  ScopeKey.prototype.toString = function () {
    return 'ScopeKey(scopeId=' + toString_0(this.s4q_1) + ', arg=' + this.t4q_1 + ')';
  };
  ScopeKey.prototype.hashCode = function () {
    var result = hashCode(this.s4q_1);
    result = imul(result, 31) + (this.t4q_1 == null ? 0 : hashCode(this.t4q_1)) | 0;
    return result;
  };
  ScopeKey.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeKey))
      return false;
    var tmp0_other_with_cast = other instanceof ScopeKey ? other : THROW_CCE();
    if (!equals(this.s4q_1, tmp0_other_with_cast.s4q_1))
      return false;
    if (!equals(this.t4q_1, tmp0_other_with_cast.t4q_1))
      return false;
    return true;
  };
  ScopeKey.$metadata$ = classMeta('ScopeKey');
  function toProvider(_this__u8e3s4, arg) {
    return toProvider$lambda(_this__u8e3s4, arg);
  }
  function toProvider$lambda($this_toProvider, $arg) {
    return function () {
      return $this_toProvider($arg());
    };
  }
  function DIMainBuilderImpl(allowSilentOverride) {
    DIBuilderImpl.call(this, null, '', HashSet_init_$Create$(), new DIContainerBuilderImpl(true, allowSilentOverride, HashMap_init_$Create$(), ArrayList_init_$Create$(), ArrayList_init_$Create$()));
    this.z4q_1 = ArrayList_init_$Create$();
    this.a4r_1 = Companion_getInstance_0().b4o_1;
    this.b4r_1 = Companion_getInstance_0().c4o_1;
  }
  DIMainBuilderImpl.prototype.v4o = function () {
    return this.z4q_1;
  };
  DIMainBuilderImpl.prototype.c4r = function () {
    return this.a4r_1;
  };
  DIMainBuilderImpl.prototype.d4r = function () {
    return this.b4r_1;
  };
  DIMainBuilderImpl.$metadata$ = classMeta('DIMainBuilderImpl', [MainBuilder], undefined, undefined, undefined, DIBuilderImpl.prototype);
  function DIBuilderImpl(moduleName, prefix, importedModules, containerBuilder) {
    this.e4r_1 = moduleName;
    this.f4r_1 = prefix;
    this.g4r_1 = importedModules;
    this.h4r_1 = containerBuilder;
    this.i4r_1 = Companion_getInstance().q4m_1;
  }
  DIBuilderImpl.prototype.j4r = function () {
    return this.h4r_1;
  };
  DIBuilderImpl.prototype.m4n = function () {
    return this.i4r_1;
  };
  DIBuilderImpl.prototype.l4n = function () {
    return new NoScope();
  };
  DIBuilderImpl.prototype.n4n = function () {
    return false;
  };
  DIBuilderImpl.prototype.u4n = function (tag, overrides, binding) {
    this.j4r().o4r(new Key(binding.m4n(), binding.p4n(), binding.o4p(), tag), binding, this.e4r_1, overrides);
  };
  DIBuilderImpl.prototype.v4n = function (module_0, allowOverride) {
    var moduleName = this.f4r_1 + module_0.x4n_1;
    var tmp;
    var tmp$ret$0;
    // Inline function 'kotlin.text.isNotEmpty' call
    tmp$ret$0 = charSequenceLength(moduleName) > 0;
    if (tmp$ret$0) {
      tmp = this.g4r_1.p1(moduleName);
    } else {
      tmp = false;
    }
    if (tmp) {
      throw IllegalStateException_init_$Create$('Module "' + moduleName + '" has already been imported!');
    }
    var tmp0_this = this;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.g4r_1;
    tmp0_plusAssign.b(moduleName);
    var tmp$ret$1;
    // Inline function 'kotlin.apply' call
    var tmp1_apply = new DIBuilderImpl(moduleName, this.f4r_1 + module_0.z4n_1, this.g4r_1, this.j4r().p4r(allowOverride, module_0.y4n_1));
    var tmp2_apply = module_0.a4o_1;
    // Inline function 'kotlin.contracts.contract' call
    tmp2_apply(tmp1_apply);
    tmp$ret$1 = tmp1_apply;
  };
  DIBuilderImpl.$metadata$ = classMeta('DIBuilderImpl', [Builder]);
  function DIContainerBuilderImpl$OverrideMode$ALLOW_SILENT() {
    OverrideMode.call(this, 'ALLOW_SILENT', 0);
    OverrideMode_ALLOW_SILENT_instance = this;
  }
  DIContainerBuilderImpl$OverrideMode$ALLOW_SILENT.prototype.s4r = function () {
    return true;
  };
  DIContainerBuilderImpl$OverrideMode$ALLOW_SILENT.prototype.t4r = function (overrides) {
    return overrides;
  };
  DIContainerBuilderImpl$OverrideMode$ALLOW_SILENT.$metadata$ = classMeta('ALLOW_SILENT', undefined, undefined, undefined, undefined, OverrideMode.prototype);
  var OverrideMode_ALLOW_SILENT_instance;
  function DIContainerBuilderImpl$OverrideMode$ALLOW_EXPLICIT() {
    OverrideMode.call(this, 'ALLOW_EXPLICIT', 1);
    OverrideMode_ALLOW_EXPLICIT_instance = this;
  }
  DIContainerBuilderImpl$OverrideMode$ALLOW_EXPLICIT.prototype.s4r = function () {
    return true;
  };
  DIContainerBuilderImpl$OverrideMode$ALLOW_EXPLICIT.prototype.t4r = function (overrides) {
    var tmp0_elvis_lhs = overrides;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  };
  DIContainerBuilderImpl$OverrideMode$ALLOW_EXPLICIT.$metadata$ = classMeta('ALLOW_EXPLICIT', undefined, undefined, undefined, undefined, OverrideMode.prototype);
  var OverrideMode_ALLOW_EXPLICIT_instance;
  function DIContainerBuilderImpl$OverrideMode$FORBID() {
    OverrideMode.call(this, 'FORBID', 2);
    OverrideMode_FORBID_instance = this;
  }
  DIContainerBuilderImpl$OverrideMode$FORBID.prototype.s4r = function () {
    return false;
  };
  DIContainerBuilderImpl$OverrideMode$FORBID.prototype.t4r = function (overrides) {
    var tmp;
    if (!(overrides == null) ? overrides : false) {
      throw new OverridingException('Overriding has been forbidden');
    } else {
      tmp = false;
    }
    return tmp;
  };
  DIContainerBuilderImpl$OverrideMode$FORBID.$metadata$ = classMeta('FORBID', undefined, undefined, undefined, undefined, OverrideMode.prototype);
  var OverrideMode_FORBID_instance;
  function Companion_2() {
    Companion_instance_2 = this;
  }
  Companion_2.prototype.y4r = function (allow, silent) {
    if (!allow)
      return OverrideMode_FORBID_getInstance();
    if (silent)
      return OverrideMode_ALLOW_SILENT_getInstance();
    return OverrideMode_ALLOW_EXPLICIT_getInstance();
  };
  Companion_2.$metadata$ = objectMeta('Companion');
  var Companion_instance_2;
  function Companion_getInstance_3() {
    OverrideMode_initEntries();
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  var OverrideMode_entriesInitialized;
  function OverrideMode_initEntries() {
    if (OverrideMode_entriesInitialized)
      return Unit_getInstance();
    OverrideMode_entriesInitialized = true;
    OverrideMode_ALLOW_SILENT_instance = new DIContainerBuilderImpl$OverrideMode$ALLOW_SILENT();
    OverrideMode_ALLOW_EXPLICIT_instance = new DIContainerBuilderImpl$OverrideMode$ALLOW_EXPLICIT();
    OverrideMode_FORBID_instance = new DIContainerBuilderImpl$OverrideMode$FORBID();
    Companion_getInstance_3();
  }
  function OverrideMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  OverrideMode.$metadata$ = classMeta('OverrideMode', undefined, undefined, undefined, undefined, Enum.prototype);
  function checkOverrides($this, key, overrides) {
    var mustOverride = $this.n4r_1.t4r(overrides);
    if (!(mustOverride == null)) {
      var tmp;
      if (mustOverride) {
        var tmp$ret$1;
        // Inline function 'kotlin.collections.contains' call
        var tmp0_contains = $this.k4r_1;
        var tmp$ret$0;
        // Inline function 'kotlin.collections.containsKey' call
        tmp$ret$0 = (isInterface(tmp0_contains, Map) ? tmp0_contains : THROW_CCE()).g2(key);
        tmp$ret$1 = tmp$ret$0;
        tmp = !tmp$ret$1;
      } else {
        tmp = false;
      }
      if (tmp)
        throw new OverridingException('Binding ' + key + ' must override an existing binding.');
      var tmp_0;
      if (!mustOverride) {
        var tmp$ret$3;
        // Inline function 'kotlin.collections.contains' call
        var tmp1_contains = $this.k4r_1;
        var tmp$ret$2;
        // Inline function 'kotlin.collections.containsKey' call
        tmp$ret$2 = (isInterface(tmp1_contains, Map) ? tmp1_contains : THROW_CCE()).g2(key);
        tmp$ret$3 = tmp$ret$2;
        tmp_0 = tmp$ret$3;
      } else {
        tmp_0 = false;
      }
      if (tmp_0)
        throw new OverridingException('Binding ' + key + ' must not override an existing binding.');
    }
  }
  function checkMatch($this, allowOverride) {
    if (!$this.n4r_1.s4r() ? allowOverride : false)
      throw new OverridingException('Overriding has been forbidden');
  }
  function OverrideMode_ALLOW_SILENT_getInstance() {
    OverrideMode_initEntries();
    return OverrideMode_ALLOW_SILENT_instance;
  }
  function OverrideMode_ALLOW_EXPLICIT_getInstance() {
    OverrideMode_initEntries();
    return OverrideMode_ALLOW_EXPLICIT_instance;
  }
  function OverrideMode_FORBID_getInstance() {
    OverrideMode_initEntries();
    return OverrideMode_FORBID_instance;
  }
  function DIContainerBuilderImpl(allowOverride, silentOverride, bindingsMap, callbacks, translators) {
    this.k4r_1 = bindingsMap;
    this.l4r_1 = callbacks;
    this.m4r_1 = translators;
    this.n4r_1 = Companion_getInstance_3().y4r(allowOverride, silentOverride);
  }
  DIContainerBuilderImpl.prototype.o4r = function (key, binding, fromModule, overrides) {
    checkOverrides(this, key, overrides);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.getOrPut' call
    var tmp0_getOrPut = this.k4r_1;
    var value = tmp0_getOrPut.p(key);
    var tmp;
    if (value == null) {
      var tmp$ret$0;
      // Inline function 'org.kodein.di.internal.DIContainerBuilderImpl.bind.<anonymous>' call
      tmp$ret$0 = newLinkedList();
      var answer = tmp$ret$0;
      tmp0_getOrPut.a(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    tmp$ret$1 = tmp;
    var bindings = tmp$ret$1;
    bindings.vb(0, new DIDefining(isInterface(binding, DIBinding) ? binding : THROW_CCE(), fromModule));
  };
  DIContainerBuilderImpl.prototype.p4r = function (allowOverride, silentOverride) {
    checkMatch(this, allowOverride);
    return new DIContainerBuilderImpl(allowOverride, silentOverride, this.k4r_1, this.l4r_1, this.m4r_1);
  };
  DIContainerBuilderImpl.$metadata$ = classMeta('DIContainerBuilderImpl', [Builder_0]);
  function displayString($this, key, overrideLevel) {
    var descProp = $this.e4s_1 ? bindFullDescription$factory_0(key) : bindDescription$factory_0(key);
    return !(overrideLevel === 0) ? 'overridden ' + descProp.get() : descProp.get();
  }
  function recursiveLoop($this, node, firstKey, firstOverrideLevel, tail) {
    var $this_0 = $this;
    var node_0 = node;
    var firstKey_0 = firstKey;
    var firstOverrideLevel_0 = firstOverrideLevel;
    var tail_0 = tail;
    $l$1: do {
      $l$0: do {
        var tmp;
        if (node_0.d4s_1 == null ? true : firstKey_0.equals(node_0.b4s_1) ? firstOverrideLevel_0 === node_0.c4s_1 : false) {
          tmp = plus(listOf(displayString($this_0, node_0.b4s_1, node_0.c4s_1)), tail_0);
        } else {
          var tmp0 = $this_0;
          var tmp1 = node_0.d4s_1;
          var tmp2 = firstKey_0;
          var tmp3 = firstOverrideLevel_0;
          var tmp4 = plus(listOf(displayString($this_0, node_0.b4s_1, node_0.c4s_1)), tail_0);
          $this_0 = tmp0;
          node_0 = tmp1;
          firstKey_0 = tmp2;
          firstOverrideLevel_0 = tmp3;
          tail_0 = tmp4;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function recursiveCheck($this, node, searchedKey, searchedOverrideLevel) {
    var $this_0 = $this;
    var node_0 = node;
    var searchedKey_0 = searchedKey;
    var searchedOverrideLevel_0 = searchedOverrideLevel;
    $l$1: do {
      $l$0: do {
        var tmp;
        if (node_0.b4s_1.equals(searchedKey_0) ? node_0.c4s_1 === searchedOverrideLevel_0 : false) {
          tmp = false;
        } else if (node_0.d4s_1 == null) {
          tmp = true;
        } else {
          var tmp0 = $this_0;
          var tmp1 = node_0.d4s_1;
          var tmp2 = searchedKey_0;
          var tmp3 = searchedOverrideLevel_0;
          $this_0 = tmp0;
          node_0 = tmp1;
          searchedKey_0 = tmp2;
          searchedOverrideLevel_0 = tmp3;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function DIContainerImpl_init_$Init$(builder, externalSources, fullDescriptionOnError, fullContainerTreeOnError, runCallbacks, $this) {
    DIContainerImpl.call($this, new DITreeImpl(builder.k4r_1, externalSources, builder.m4r_1), null, fullDescriptionOnError, fullContainerTreeOnError);
    var init = DIContainerImpl$_init_$lambda_r6ib3j($this, builder);
    if (runCallbacks)
      init();
    else {
      var lock = new Object();
      var tmp = $this;
      tmp.j4s_1 = DIContainerImpl$_init_$lambda_r6ib3j_0($this, init);
    }
    return $this;
  }
  function DIContainerImpl_init_$Create$(builder, externalSources, fullDescriptionOnError, fullContainerTreeOnError, runCallbacks) {
    return DIContainerImpl_init_$Init$(builder, externalSources, fullDescriptionOnError, fullContainerTreeOnError, runCallbacks, Object.create(DIContainerImpl.prototype));
  }
  function Node(key, overrideLevel, parent, fullDescriptionOnError) {
    this.b4s_1 = key;
    this.c4s_1 = overrideLevel;
    this.d4s_1 = parent;
    this.e4s_1 = fullDescriptionOnError;
  }
  Node.prototype.k4s = function (searchedKey, searchedOverrideLevel) {
    if (!recursiveCheck(this, this, searchedKey, searchedOverrideLevel)) {
      var list = plus_0(recursiveLoop(this, this, searchedKey, searchedOverrideLevel, emptyList()), displayString(this, searchedKey, this.c4s_1));
      var sb = StringBuilder_init_$Create$();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = list.d();
      while (tmp0_iterator.e()) {
        var item = tmp0_iterator.f();
        // Inline function 'org.kodein.di.internal.Node.check.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var tmp0__anonymous__q1qw7t = checkIndexOverflow(tmp1);
        sb.r6('  ');
        var tmp0_subject = tmp0__anonymous__q1qw7t;
        switch (tmp0_subject) {
          case 0:
            sb.r6('   ');
            ;
            break;
          case 1:
            sb.r6('  \u2554\u2569>');
            ;
            break;
          default:
            sb.r6('  \u2551');
            ;
            sb.r6(repeat('  ', tmp0__anonymous__q1qw7t - 1 | 0));
            ;
            sb.r6('\u255A>');
            ;
            break;
        }
        sb.r6(item);
        sb.r6('\n');
      }
      sb.r6('    \u255A');
      sb.r6(repeat('\u2550\u2550', list.g() - 1 | 0));
      sb.r6('\u255D');
      throw new DependencyLoopException('Dependency recursion:\n' + sb);
    }
  };
  Node.$metadata$ = classMeta('Node');
  function bindingDI($this, key, context, tree, overrideLevel) {
    var container = new DIContainerImpl(tree, new Node(key, overrideLevel, $this.g4s_1, $this.h4s_1), $this.h4s_1, $this.i4s_1);
    return new BindingDIImpl(new DirectDIImpl(container, context), key, overrideLevel);
  }
  function DIContainerImpl$_init_$lambda_r6ib3j(this$0, $builder) {
    return function () {
      var direct = new DirectDIImpl(this$0, get_AnyDIContext());
      var tmp0_forEach = $builder.l4r_1;
      var tmp0_iterator = tmp0_forEach.d();
      while (tmp0_iterator.e()) {
        var element = tmp0_iterator.f();
        // Inline function 'org.kodein.di.internal.DIContainerImpl.<init>.<anonymous>.<anonymous>' call
        element(direct);
      }
      return Unit_getInstance();
    };
  }
  function DIContainerImpl$_init_$lambda_r6ib3j_0(this$0, $init) {
    return function () {
      var tmp$ret$1;
      $l$block_1: {
        // Inline function 'org.kodein.di.internal.synchronizedIfNotNull' call
        var tmp0_synchronizedIfNotNull = initCallbacks$factory(this$0);
        if (tmp0_synchronizedIfNotNull() == null) {
          var tmp$ret$0;
          // Inline function 'org.kodein.di.internal.DIContainerImpl.<init>.<anonymous>.<anonymous>' call
          tmp$ret$0 = Unit_getInstance();
          tmp$ret$1 = tmp$ret$0;
          break $l$block_1;
        }
        var tmp$ret$3;
        // Inline function 'org.kodein.di.internal.maySynchronized' call
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'org.kodein.di.internal.synchronizedIfNotNull.<anonymous>' call
          var tmp0_elvis_lhs = tmp0_synchronizedIfNotNull();
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$2 = Unit_getInstance();
            break $l$block_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var value = tmp;
          this$0.j4s_1 = null;
          tmp$ret$1 = $init();
          break $l$block_1;
        }
        tmp$ret$3 = tmp$ret$2;
        var tmp$ret$4;
        // Inline function 'org.kodein.di.internal.DIContainerImpl.<init>.<anonymous>.<anonymous>' call
        tmp$ret$4 = Unit_getInstance();
        tmp$ret$1 = tmp$ret$4;
      }
      return Unit_getInstance();
    };
  }
  function DIContainerImpl$factory$lambda($this$null, it) {
    return fullDescription$default($this$null, it, 0, 2, null);
  }
  function DIContainerImpl$factory$lambda_0($this$null, it) {
    return description$default($this$null, it, 0, 2, null);
  }
  function DIContainerImpl(tree, node, fullDescriptionOnError, fullContainerTreeOnError) {
    this.f4s_1 = tree;
    this.g4s_1 = node;
    this.h4s_1 = fullDescriptionOnError;
    this.i4s_1 = fullContainerTreeOnError;
    this.j4s_1 = null;
  }
  DIContainerImpl.prototype.l4s = function () {
    return this.f4s_1;
  };
  DIContainerImpl.prototype.r4o = function (key, context, overrideLevel) {
    var result = this.f4s_1.x4o(key, overrideLevel, false, 4, null);
    if (result.g() === 1) {
      var tmp0_container = result.h(0);
      var definition = tmp0_container.l3();
      var translator = tmp0_container.u8();
      var tmp1_safe_receiver = this.g4s_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.k4s(key, overrideLevel);
      }
      var tmp = Companion_getInstance_1().l4o(key.c4n_1, context);
      var originalContext = isInterface(tmp, DIContext) ? tmp : THROW_CCE();
      var tmp2_safe_receiver = translator;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toKContext(tmp2_safe_receiver, new DirectDIImpl(this, originalContext), context);
      var kContext = tmp3_elvis_lhs == null ? originalContext : tmp3_elvis_lhs;
      if (key instanceof Key)
        key;
      else
        THROW_CCE();
      var bindingDI_0 = bindingDI(this, key, kContext, definition.x4m_1, overrideLevel);
      return definition.y4m_1.q4p(key, bindingDI_0);
    }
    var bindingDI_1 = bindingDI(this, key, Companion_getInstance_1().l4o(key.c4n_1, context), this.f4s_1, overrideLevel);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.f4s_1.v4o();
    var tmp0_iterator = tmp0_forEach.d();
    while (tmp0_iterator.e()) {
      var element = tmp0_iterator.f();
      // Inline function 'org.kodein.di.internal.DIContainerImpl.factory.<anonymous>' call
      var tmp0_safe_receiver = element.m4s(bindingDI_1, key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$0;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_safe_receiver_0 = this.g4s_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.k4s(key, overrideLevel);
        }
        return (!(tmp0_safe_receiver == null) ? typeof tmp0_safe_receiver === 'function' : false) ? tmp0_safe_receiver : THROW_CCE();
      }
    }
    var withOverrides = !(overrideLevel === 0);
    var descProp = this.h4s_1 ? fullDescription$factory_0(key) : description$factory_0(key);
    var tmp_0;
    if (this.h4s_1) {
      tmp_0 = DIContainerImpl$factory$lambda;
    } else {
      tmp_0 = DIContainerImpl$factory$lambda_0;
    }
    var descFun = tmp_0;
    if (result.m()) {
      var tmp$ret$7;
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$6;
      // Inline function 'kotlin.apply' call
      var tmp0_apply = StringBuilder_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.kodein.di.internal.DIContainerImpl.factory.<anonymous>' call
      tmp0_apply.r6('No binding found for ' + descProp.get());
      if (this.i4s_1) {
        var tmp$ret$1;
        // Inline function 'kotlin.text.appendLine' call
        tmp$ret$1 = tmp0_apply.p6(_Char___init__impl__6a9atx(10));
        var forType = this.f4s_1.y4o(SearchSpecs_init_$Create$(null, null, key.e4n_1, null, 11, null));
        var tmp$ret$2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp$ret$2 = !forType.m();
        if (tmp$ret$2) {
          var tmp$ret$5;
          // Inline function 'kotlin.collections.associate' call
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(forType, 10)), 16);
          var tmp$ret$4;
          // Inline function 'kotlin.collections.associateTo' call
          var tmp1_associateTo = LinkedHashMap_init_$Create$_0(capacity);
          var tmp0_iterator_0 = forType.d();
          while (tmp0_iterator_0.e()) {
            var element_0 = tmp0_iterator_0.f();
            // Inline function 'kotlin.collections.plusAssign' call
            var tmp$ret$3;
            // Inline function 'org.kodein.di.internal.DIContainerImpl.factory.<anonymous>.<anonymous>' call
            tmp$ret$3 = to(element_0.q8_1, element_0.r8_1);
            var tmp0_plusAssign = tmp$ret$3;
            tmp1_associateTo.a(tmp0_plusAssign.n_1, tmp0_plusAssign.o_1);
          }
          tmp$ret$4 = tmp1_associateTo;
          tmp$ret$5 = tmp$ret$4;
          tmp0_apply.r6('Available bindings for this type:\n' + descFun(tmp$ret$5, withOverrides));
        }
        tmp0_apply.r6('Registered in this DI container:\n' + descFun(this.f4s_1.u4o(), withOverrides));
      }
      tmp$ret$6 = tmp0_apply;
      tmp$ret$7 = tmp$ret$6.toString();
      var description = tmp$ret$7;
      throw new NotFoundException(key, description);
    }
    var tmp$ret$10;
    // Inline function 'kotlin.collections.associate' call
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(result, 10)), 16);
    var tmp$ret$9;
    // Inline function 'kotlin.collections.associateTo' call
    var tmp1_associateTo_0 = LinkedHashMap_init_$Create$_0(capacity_0);
    var tmp0_iterator_1 = result.d();
    while (tmp0_iterator_1.e()) {
      var element_1 = tmp0_iterator_1.f();
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp$ret$8;
      // Inline function 'org.kodein.di.internal.DIContainerImpl.factory.<anonymous>' call
      tmp$ret$8 = to(element_1.q8_1, ensureNotNull(this.f4s_1.z4o(element_1.q8_1)).r8_1);
      var tmp0_plusAssign_0 = tmp$ret$8;
      tmp1_associateTo_0.a(tmp0_plusAssign_0.n_1, tmp0_plusAssign_0.o_1);
    }
    tmp$ret$9 = tmp1_associateTo_0;
    tmp$ret$10 = tmp$ret$9;
    var potentials = tmp$ret$10;
    var tmp$ret$15;
    // Inline function 'kotlin.collections.filter' call
    var tmp1_filter = this.f4s_1.u4o();
    var tmp$ret$14;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = LinkedHashMap_init_$Create$();
    var tmp$ret$11;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$11 = tmp1_filter.v().d();
    var tmp0_iterator_2 = tmp$ret$11;
    while (tmp0_iterator_2.e()) {
      var element_2 = tmp0_iterator_2.f();
      var tmp$ret$13;
      // Inline function 'org.kodein.di.internal.DIContainerImpl.factory.<anonymous>' call
      var tmp$ret$12;
      // Inline function 'kotlin.collections.component1' call
      tmp$ret$12 = element_2.w();
      var key_0 = tmp$ret$12;
      tmp$ret$13 = !potentials.m2().p1(key_0);
      if (tmp$ret$13) {
        tmp0_filterTo.a(element_2.w(), element_2.x());
      }
    }
    tmp$ret$14 = tmp0_filterTo;
    tmp$ret$15 = tmp$ret$14;
    var others = tmp$ret$15;
    throw new NotFoundException(key, '' + potentials.g() + ' bindings found that match ' + key + ':\n' + descFun(potentials, withOverrides) + 'Other bindings registered in DI:\n' + descFun(others, withOverrides));
  };
  DIContainerImpl.$metadata$ = classMeta('DIContainerImpl', [DIContainer]);
  function bindFullDescription$factory_0($b0) {
    return getPropertyCallableRef('bindFullDescription', 0, KProperty0, function () {
      return $b0.j4n();
    }, null);
  }
  function bindDescription$factory_0($b0) {
    return getPropertyCallableRef('bindDescription', 0, KProperty0, function () {
      return $b0.h4n();
    }, null);
  }
  function fullDescription$factory_0($b0) {
    return getPropertyCallableRef('fullDescription', 0, KProperty0, function () {
      return $b0.k4n();
    }, null);
  }
  function description$factory_0($b0) {
    return getPropertyCallableRef('description', 0, KProperty0, function () {
      return $b0.i4n();
    }, null);
  }
  function initCallbacks$factory($b0) {
    return getPropertyCallableRef('initCallbacks', 0, KMutableProperty0, function () {
      return $b0.j4s_1;
    }, function (value) {
      $b0.j4s_1 = value;
      return Unit_getInstance();
    });
  }
  function newBuilder($this, allowSilentOverride, init) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new DIMainBuilderImpl(allowSilentOverride);
    // Inline function 'kotlin.contracts.contract' call
    init(tmp0_apply);
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  }
  function DIImpl_init_$Init$(builder, runCallbacks, $this) {
    DIImpl.call($this, DIContainerImpl_init_$Create$(builder.j4r(), builder.v4o(), builder.c4r(), builder.d4r(), runCallbacks));
    return $this;
  }
  function DIImpl_init_$Init$_0(allowSilentOverride, init, $this) {
    DIImpl_init_$Init$(newBuilder(Companion_getInstance_4(), allowSilentOverride, init), true, $this);
    return $this;
  }
  function DIImpl_init_$Create$(allowSilentOverride, init) {
    return DIImpl_init_$Init$_0(allowSilentOverride, init, Object.create(DIImpl.prototype));
  }
  function Companion_3() {
    Companion_instance_3 = this;
  }
  Companion_3.$metadata$ = objectMeta('Companion');
  var Companion_instance_3;
  function Companion_getInstance_4() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function DIImpl$container$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (!(this$0.n4s_1.j4s_1 == null)) {
        throw IllegalStateException_init_$Create$('DI has not been initialized');
      }
      return this$0.n4s_1;
    };
  }
  function DIImpl(_container) {
    Companion_getInstance_4();
    this.n4s_1 = _container;
    var tmp = this;
    tmp.o4s_1 = lazy(DIImpl$container$delegate$lambda(this));
  }
  DIImpl.prototype.g4o = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = container$factory();
    tmp$ret$0 = this.o4s_1.x();
    return tmp$ret$0;
  };
  DIImpl.$metadata$ = classMeta('DIImpl', [DI]);
  function BindingDIImpl(directDI, key, overrideLevel) {
    this.p4s_1 = directDI;
    this.q4s_1 = key;
    this.r4s_1 = overrideLevel;
  }
  BindingDIImpl.prototype.b4p = function () {
    return this.p4s_1;
  };
  BindingDIImpl.prototype.f4o = function () {
    return this.p4s_1.f4o();
  };
  BindingDIImpl.prototype.a4p = function () {
    return this.p4s_1.a4p();
  };
  BindingDIImpl.prototype.i4p = function (type, tag) {
    return this.p4s_1.i4p(type, tag);
  };
  BindingDIImpl.prototype.h4p = function (context) {
    return this.p4s_1.h4p(context);
  };
  BindingDIImpl.prototype.m4 = function () {
    var tmp = this.b4p().f4o().h4o().x();
    return isObject(tmp) ? tmp : THROW_CCE();
  };
  BindingDIImpl.prototype.g4p = function () {
    return new BindingDIImpl(this.b4p().h4p(ErasedContext_getInstance()), this.q4s_1, this.r4s_1);
  };
  BindingDIImpl.$metadata$ = classMeta('BindingDIImpl', [DirectDI, BindingDI]);
  function container$factory() {
    return getPropertyCallableRef('container', 1, KProperty1, function (receiver) {
      return receiver.g4o();
    }, null);
  }
  function findBySpecs($this, specs) {
    var bindSeq = asSequence($this.v4s_1);
    var specsBindType = specs.e4p_1;
    if (!(specsBindType == null) ? !equals(specsBindType, Companion_getInstance().q4m_1) : false) {
      var tmp = bindSeq;
      bindSeq = filter(tmp, DITreeImpl$findBySpecs$lambda(specsBindType));
    }
    var tmp_0 = bindSeq;
    var contextSeq = flatMap(tmp_0, DITreeImpl$findBySpecs$lambda_0);
    var specsContextType = specs.c4p_1;
    if (!(specsContextType == null)) {
      var tmp_1 = contextSeq;
      contextSeq = mapNotNull(tmp_1, DITreeImpl$findBySpecs$lambda_1(specsContextType, $this));
    }
    var tmp_2 = contextSeq;
    var argSeq = flatMap(tmp_2, DITreeImpl$findBySpecs$lambda_2);
    var specsArgType = specs.d4p_1;
    if (!(specsArgType == null)) {
      var tmp_3 = argSeq;
      argSeq = filter(tmp_3, DITreeImpl$findBySpecs$lambda_3(specsArgType));
    }
    var tmp_4 = argSeq;
    var tagSeq = flatMap(tmp_4, DITreeImpl$findBySpecs$lambda_4);
    var specsTag = specs.f4p_1;
    if (!equals(specsTag, NoDefinedTag_getInstance())) {
      var tmp_5 = tagSeq;
      tagSeq = filter(tmp_5, DITreeImpl$findBySpecs$lambda_5(specsTag));
    }
    var tmp_6 = tagSeq;
    var resultSeq = map(tmp_6, DITreeImpl$findBySpecs$lambda_6);
    return toList(resultSeq);
  }
  function notInMap($this, result, request) {
    var tmp = result.r4n();
    var tmp_0 = request.r4n();
    var tmp_1 = $this.u4s_1.m2();
    return IllegalStateException_init_$Create$('Tree returned key ' + tmp + ' that is not in cache when searching for ' + tmp_0 + '.\nKeys in cache:\n' + joinToString$default(tmp_1, '\n', null, null, 0, null, DITreeImpl$notInMap$lambda, 30, null));
  }
  function DITreeImpl$findBySpecs$lambda($specsBindType) {
    return function (_name_for_destructuring_parameter_0__wldtmu) {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.component1' call
      tmp$ret$0 = _name_for_destructuring_parameter_0__wldtmu.w();
      var bindType = tmp$ret$0;
      return bindType.y4s($specsBindType);
    };
  }
  function DITreeImpl$findBySpecs$lambda_0(_name_for_destructuring_parameter_0__wldtmu) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.component2' call
    tmp$ret$0 = _name_for_destructuring_parameter_0__wldtmu.x();
    var contextTree = tmp$ret$0;
    var tmp = asSequence(contextTree);
    return map(tmp, DITreeImpl$findBySpecs$lambda$lambda);
  }
  function DITreeImpl$findBySpecs$lambda$lambda(it) {
    return new Triple(it.w(), it.x(), null);
  }
  function DITreeImpl$findBySpecs$lambda_1($specsContextType, this$0) {
    return function (triple) {
      var tmp0_container = triple;
      var contextType = tmp0_container.k3();
      var tmp;
      if (contextType.y4s($specsContextType)) {
        tmp = triple;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_firstOrNull = this$0.x4s_1;
          var tmp0_iterator = tmp0_firstOrNull.d();
          while (tmp0_iterator.e()) {
            var element = tmp0_iterator.f();
            var tmp$ret$0;
            // Inline function 'org.kodein.di.internal.DITreeImpl.findBySpecs.<anonymous>.<anonymous>' call
            tmp$ret$0 = element.m4n().m4m($specsContextType) ? contextType.y4s(element.v4p()) : false;
            if (tmp$ret$0) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var translator = tmp$ret$1;
        var tmp_0;
        if (!(translator == null)) {
          tmp_0 = triple.w8(null, null, translator, 3, null);
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      }
      return tmp;
    };
  }
  function DITreeImpl$findBySpecs$lambda_2(_name_for_destructuring_parameter_0__wldtmu) {
    var argumentTree = _name_for_destructuring_parameter_0__wldtmu.l3();
    var translator = _name_for_destructuring_parameter_0__wldtmu.u8();
    var tmp = asSequence(argumentTree);
    return map(tmp, DITreeImpl$findBySpecs$lambda$lambda_0(translator));
  }
  function DITreeImpl$findBySpecs$lambda$lambda_0($translator) {
    return function (it) {
      return new Triple(it.w(), it.x(), $translator);
    };
  }
  function DITreeImpl$findBySpecs$lambda_3($specsArgType) {
    return function (_name_for_destructuring_parameter_0__wldtmu) {
      var argType = _name_for_destructuring_parameter_0__wldtmu.k3();
      return argType.y4s($specsArgType);
    };
  }
  function DITreeImpl$findBySpecs$lambda_4(_name_for_destructuring_parameter_0__wldtmu) {
    var tagTree = _name_for_destructuring_parameter_0__wldtmu.l3();
    var translator = _name_for_destructuring_parameter_0__wldtmu.u8();
    var tmp = asSequence(tagTree);
    return map(tmp, DITreeImpl$findBySpecs$lambda$lambda_1(translator));
  }
  function DITreeImpl$findBySpecs$lambda$lambda_1($translator) {
    return function (it) {
      return new Triple(it.w(), it.x(), $translator);
    };
  }
  function DITreeImpl$findBySpecs$lambda_5($specsTag) {
    return function (_name_for_destructuring_parameter_0__wldtmu) {
      var tag = _name_for_destructuring_parameter_0__wldtmu.k3();
      return equals(tag, $specsTag);
    };
  }
  function DITreeImpl$findBySpecs$lambda_6(_name_for_destructuring_parameter_0__wldtmu) {
    var key = _name_for_destructuring_parameter_0__wldtmu.l3();
    var translator = _name_for_destructuring_parameter_0__wldtmu.u8();
    return to(key, translator);
  }
  function DITreeImpl$notInMap$lambda(it) {
    return it.r4n();
  }
  function DITreeImpl(map, externalSources, registeredTranslators) {
    this.s4s_1 = externalSources;
    this.t4s_1 = registeredTranslators;
    this.u4s_1 = newConcurrentMap();
    this.v4s_1 = HashMap_init_$Create$();
    this.x4s_1 = ArrayList_init_$Create$_1(this.t4s_1);
    // Inline function 'kotlin.collections.forEach' call
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = map.v().d();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.e()) {
      var element = tmp0_iterator.f();
      // Inline function 'org.kodein.di.internal.DITreeImpl.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.component1' call
      tmp$ret$1 = element.w();
      var key = tmp$ret$1;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.component2' call
      tmp$ret$2 = element.x();
      var bindings = tmp$ret$2;
      var tmp$ret$5;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$4;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(bindings, 10));
      var tmp0_iterator_0 = bindings.d();
      while (tmp0_iterator_0.e()) {
        var item = tmp0_iterator_0.f();
        var tmp$ret$3;
        // Inline function 'org.kodein.di.internal.DITreeImpl.<anonymous>.<anonymous>' call
        var tmp0_subject = item;
        var tmp;
        if (tmp0_subject instanceof DIDefinition) {
          tmp = item;
        } else {
          tmp = new DIDefinition(item.y4m_1, item.z4m_1, this);
        }
        tmp$ret$3 = tmp;
        tmp0_mapTo.b(tmp$ret$3);
      }
      tmp$ret$4 = tmp0_mapTo;
      tmp$ret$5 = tmp$ret$4;
      var definitions = tmp$ret$5;
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.u4s_1;
      var tmp1_set = new Triple(key, definitions, null);
      tmp0_set.a(key, tmp1_set);
      var typeChecker = first(bindings).y4m_1.p4p() ? new Down(key.e4n_1) : new Up(key.e4n_1);
      var tmp$ret$7;
      // Inline function 'kotlin.collections.getOrPut' call
      var tmp2_getOrPut = this.v4s_1;
      var value = tmp2_getOrPut.p(typeChecker);
      var tmp_0;
      if (value == null) {
        var tmp$ret$6;
        // Inline function 'org.kodein.di.internal.DITreeImpl.<anonymous>.<anonymous>' call
        tmp$ret$6 = HashMap_init_$Create$();
        var answer = tmp$ret$6;
        tmp2_getOrPut.a(typeChecker, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      tmp$ret$7 = tmp_0;
      var contextTree = tmp$ret$7;
      var tmp$ret$9;
      // Inline function 'kotlin.collections.getOrPut' call
      var tmp3_getOrPut = new Down(key.c4n_1);
      var value_0 = contextTree.p(tmp3_getOrPut);
      var tmp_1;
      if (value_0 == null) {
        var tmp$ret$8;
        // Inline function 'org.kodein.di.internal.DITreeImpl.<anonymous>.<anonymous>' call
        tmp$ret$8 = HashMap_init_$Create$();
        var answer_0 = tmp$ret$8;
        contextTree.a(tmp3_getOrPut, answer_0);
        tmp_1 = answer_0;
      } else {
        tmp_1 = value_0;
      }
      tmp$ret$9 = tmp_1;
      var argumentTree = tmp$ret$9;
      var tmp$ret$11;
      // Inline function 'kotlin.collections.getOrPut' call
      var tmp4_getOrPut = new Down(key.d4n_1);
      var value_1 = argumentTree.p(tmp4_getOrPut);
      var tmp_2;
      if (value_1 == null) {
        var tmp$ret$10;
        // Inline function 'org.kodein.di.internal.DITreeImpl.<anonymous>.<anonymous>' call
        tmp$ret$10 = HashMap_init_$Create$();
        var answer_1 = tmp$ret$10;
        argumentTree.a(tmp4_getOrPut, answer_1);
        tmp_2 = answer_1;
      } else {
        tmp_2 = value_1;
      }
      tmp$ret$11 = tmp_2;
      var tagTree = tmp$ret$11;
      // Inline function 'kotlin.collections.set' call
      var tmp5_set = key.f4n_1;
      tagTree.a(tmp5_set, key);
    }
    var tmp_3 = this;
    var tmp$ret$16;
    // Inline function 'kotlin.collections.mapValues' call
    var tmp0_mapValues = this.u4s_1;
    var tmp$ret$15;
    // Inline function 'kotlin.collections.mapValuesTo' call
    var tmp1_mapValuesTo = LinkedHashMap_init_$Create$_0(mapCapacity(tmp0_mapValues.g()));
    var tmp$ret$14;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = tmp0_mapValues.v();
    var tmp0_iterator_1 = tmp0_associateByTo.d();
    while (tmp0_iterator_1.e()) {
      var element_0 = tmp0_iterator_1.f();
      var tmp$ret$12;
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      tmp$ret$12 = element_0.w();
      var tmp_4 = tmp$ret$12;
      var tmp$ret$13;
      // Inline function 'org.kodein.di.internal.DITreeImpl.<anonymous>' call
      tmp$ret$13 = element_0.x().r8_1;
      tmp1_mapValuesTo.a(tmp_4, tmp$ret$13);
    }
    tmp$ret$14 = tmp1_mapValuesTo;
    tmp$ret$15 = tmp$ret$14;
    tmp$ret$16 = tmp$ret$15;
    tmp_3.w4s_1 = HashMap_init_$Create$_0(tmp$ret$16);
    $l$loop: while (true) {
      var added = ArrayList_init_$Create$();
      var tmp0_iterator_2 = this.x4s_1.d();
      while (tmp0_iterator_2.e()) {
        var src = tmp0_iterator_2.f();
        var tmp1_iterator = this.x4s_1.d();
        while (tmp1_iterator.e()) {
          var dst = tmp1_iterator.f();
          if (dst.m4n().m4m(src.v4p()) ? !equals(src.m4n(), dst.v4p()) : false) {
            var tmp$ret$17;
            $l$block_0: {
              // Inline function 'kotlin.collections.none' call
              var tmp1_none = this.x4s_1;
              var tmp_5;
              if (isInterface(tmp1_none, Collection)) {
                tmp_5 = tmp1_none.m();
              } else {
                tmp_5 = false;
              }
              if (tmp_5) {
                tmp$ret$17 = true;
                break $l$block_0;
              }
              var tmp0_iterator_3 = tmp1_none.d();
              while (tmp0_iterator_3.e()) {
                var element_1 = tmp0_iterator_3.f();
                var tmp$ret$18;
                // Inline function 'org.kodein.di.internal.DITreeImpl.<anonymous>' call
                tmp$ret$18 = equals(element_1.m4n(), src.m4n()) ? equals(element_1.v4p(), dst.v4p()) : false;
                if (tmp$ret$18) {
                  tmp$ret$17 = false;
                  break $l$block_0;
                }
              }
              tmp$ret$17 = true;
            }
            if (tmp$ret$17) {
              // Inline function 'kotlin.collections.plusAssign' call
              var tmp_6 = isInterface(src, ContextTranslator) ? src : THROW_CCE();
              var tmp2_plusAssign = new CompositeContextTranslator(tmp_6, isInterface(dst, ContextTranslator) ? dst : THROW_CCE());
              added.b(tmp2_plusAssign);
            }
          }
        }
      }
      var tmp2_this = this;
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp3_plusAssign = tmp2_this.x4s_1;
      addAll(tmp3_plusAssign, added);
      if (added.m())
        break $l$loop;
    }
  }
  DITreeImpl.prototype.v4o = function () {
    return this.s4s_1;
  };
  DITreeImpl.prototype.u4o = function () {
    return this.w4s_1;
  };
  DITreeImpl.prototype.w4o = function (key, overrideLevel, all) {
    if (!all) {
      var tmp0_safe_receiver = this.u4s_1.p(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$0;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var realKey = tmp0_safe_receiver.k3();
        var list = tmp0_safe_receiver.l3();
        var translator = tmp0_safe_receiver.u8();
        var tmp0_elvis_lhs = getOrNull(list, overrideLevel);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return emptyList();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var definition = tmp;
        var tmp_0 = realKey instanceof Key ? realKey : THROW_CCE();
        var tmp_1 = definition instanceof DIDefinition ? definition : THROW_CCE();
        return listOf(new Triple(tmp_0, tmp_1, (translator == null ? true : isInterface(translator, ContextTranslator)) ? translator : THROW_CCE()));
      }
      if (!equals(key.c4n_1, Companion_getInstance().q4m_1)) {
        var tmp_2 = Companion_getInstance().q4m_1;
        var anyContextKey = key.t4n(tmp_2, null, null, null, 14, null);
        var tmp1_safe_receiver = this.u4s_1.p(anyContextKey);
        if (tmp1_safe_receiver == null)
          null;
        else {
          var tmp$ret$2;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'org.kodein.di.internal.DITreeImpl.find.<anonymous>' call
            var tmp0_container = tmp1_safe_receiver;
            var realKey_0 = tmp0_container.k3();
            var list_0 = tmp0_container.l3();
            var translator_0 = tmp0_container.u8();
            if (!(translator_0 == null) ? !equals(translator_0.m4n(), key.c4n_1) : false) {
              tmp$ret$1 = Unit_getInstance();
              break $l$block;
            }
            // Inline function 'kotlin.collections.set' call
            var tmp0_set = this.u4s_1;
            tmp0_set.a(key, tmp1_safe_receiver);
            var tmp1_elvis_lhs = getOrNull(list_0, overrideLevel);
            var tmp_3;
            if (tmp1_elvis_lhs == null) {
              return emptyList();
            } else {
              tmp_3 = tmp1_elvis_lhs;
            }
            var definition_0 = tmp_3;
            var tmp_4 = realKey_0 instanceof Key ? realKey_0 : THROW_CCE();
            var tmp_5 = definition_0 instanceof DIDefinition ? definition_0 : THROW_CCE();
            return listOf(new Triple(tmp_4, tmp_5, (translator_0 == null ? true : isInterface(translator_0, ContextTranslator)) ? translator_0 : THROW_CCE()));
          }
          tmp$ret$2 = tmp$ret$1;
        }
      }
      var tmp$ret$5;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_filter = this.x4s_1;
      var tmp$ret$4;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList_init_$Create$();
      var tmp0_iterator = tmp0_filter.d();
      while (tmp0_iterator.e()) {
        var element = tmp0_iterator.f();
        var tmp$ret$3;
        // Inline function 'org.kodein.di.internal.DITreeImpl.find.<anonymous>' call
        tmp$ret$3 = equals(element.m4n(), key.c4n_1);
        if (tmp$ret$3) {
          tmp0_filterTo.b(element);
        }
      }
      tmp$ret$4 = tmp0_filterTo;
      tmp$ret$5 = tmp$ret$4;
      var tmp_6 = tmp$ret$5;
      var tmp$ret$8;
      // Inline function 'kotlin.collections.filter' call
      var tmp1_filter = this.x4s_1;
      var tmp$ret$7;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo_0 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = tmp1_filter.d();
      while (tmp0_iterator_0.e()) {
        var element_0 = tmp0_iterator_0.f();
        var tmp$ret$6;
        // Inline function 'org.kodein.di.internal.DITreeImpl.find.<anonymous>' call
        tmp$ret$6 = equals(element_0.m4n(), Companion_getInstance().q4m_1);
        if (tmp$ret$6) {
          tmp0_filterTo_0.b(element_0);
        }
      }
      tmp$ret$7 = tmp0_filterTo_0;
      tmp$ret$8 = tmp$ret$7;
      var applicableTranslators = plus(tmp_6, tmp$ret$8);
      var tmp2_iterator = applicableTranslators.d();
      while (tmp2_iterator.e()) {
        var translator_1 = tmp2_iterator.f();
        var translatedKey = new Key(translator_1.v4p(), key.d4n_1, key.e4n_1, key.f4n_1);
        var tmp3_safe_receiver = this.u4s_1.p(translatedKey);
        var tmp_7;
        if (tmp3_safe_receiver == null) {
          tmp_7 = null;
        } else {
          var tmp$ret$10;
          // Inline function 'kotlin.takeIf' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_8;
          var tmp$ret$9;
          // Inline function 'org.kodein.di.internal.DITreeImpl.find.<anonymous>' call
          tmp$ret$9 = tmp3_safe_receiver.s8_1 == null;
          if (tmp$ret$9) {
            tmp_8 = tmp3_safe_receiver;
          } else {
            tmp_8 = null;
          }
          tmp$ret$10 = tmp_8;
          tmp_7 = tmp$ret$10;
        }
        var tmp4_safe_receiver = tmp_7;
        if (tmp4_safe_receiver == null)
          null;
        else {
          var tmp$ret$12;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp$ret$11;
          $l$block_0: {
            // Inline function 'org.kodein.di.internal.DITreeImpl.find.<anonymous>' call
            if (!(tmp4_safe_receiver.s8_1 == null)) {
              tmp$ret$11 = Unit_getInstance();
              break $l$block_0;
            }
            // Inline function 'kotlin.collections.set' call
            var tmp0_set_0 = this.u4s_1;
            var tmp1_set = tmp4_safe_receiver.w8(null, null, translator_1, 3, null);
            tmp0_set_0.a(key, tmp1_set);
            var tmp0_container_0 = tmp4_safe_receiver;
            var realKey_1 = tmp0_container_0.k3();
            var list_1 = tmp0_container_0.l3();
            var tmp1_elvis_lhs_0 = getOrNull(list_1, overrideLevel);
            var tmp_9;
            if (tmp1_elvis_lhs_0 == null) {
              return emptyList();
            } else {
              tmp_9 = tmp1_elvis_lhs_0;
            }
            var definition_1 = tmp_9;
            var tmp_10 = realKey_1 instanceof Key ? realKey_1 : THROW_CCE();
            var tmp_11 = definition_1 instanceof DIDefinition ? definition_1 : THROW_CCE();
            return listOf(new Triple(tmp_10, tmp_11, isInterface(translator_1, ContextTranslator) ? translator_1 : THROW_CCE()));
          }
          tmp$ret$12 = tmp$ret$11;
        }
      }
    }
    var result = findBySpecs(this, new SearchSpecs(key.c4n_1, key.d4n_1, key.e4n_1, key.f4n_1));
    if (result.g() === 1) {
      var tmp5_container = first(result);
      var realKey_2 = tmp5_container.k3();
      var translator_2 = tmp5_container.l3();
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.u4s_1;
      var tmp6_safe_receiver = this.u4s_1.p(realKey_2);
      var tmp_12;
      if (tmp6_safe_receiver == null) {
        tmp_12 = null;
      } else {
        tmp_12 = tmp6_safe_receiver.w8(null, null, translator_2, 3, null);
      }
      var tmp7_elvis_lhs = tmp_12;
      var tmp_13;
      if (tmp7_elvis_lhs == null) {
        throw notInMap(this, realKey_2, key);
      } else {
        tmp_13 = tmp7_elvis_lhs;
      }
      var tmp3_set = tmp_13;
      tmp2_set.a(key, tmp3_set);
    }
    var tmp$ret$16;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp$ret$15;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = result.d();
    while (tmp0_iterator_1.e()) {
      var element_1 = tmp0_iterator_1.f();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$13;
      $l$block_1: {
        // Inline function 'org.kodein.di.internal.DITreeImpl.find.<anonymous>' call
        var realKey_3 = element_1.k3();
        var translator_3 = element_1.l3();
        var tmp0_elvis_lhs_0 = this.u4s_1.p(realKey_3);
        var tmp_14;
        if (tmp0_elvis_lhs_0 == null) {
          throw notInMap(this, realKey_3, key);
        } else {
          tmp_14 = tmp0_elvis_lhs_0;
        }
        var tmp1_container = tmp_14;
        var definitions = tmp1_container.l3();
        var tmp2_elvis_lhs = getOrNull(definitions, overrideLevel);
        var tmp_15;
        if (tmp2_elvis_lhs == null) {
          tmp$ret$13 = null;
          break $l$block_1;
        } else {
          tmp_15 = tmp2_elvis_lhs;
        }
        var definition_2 = tmp_15;
        var tmp_16 = realKey_3 instanceof Key ? realKey_3 : THROW_CCE();
        var tmp_17 = definition_2 instanceof DIDefinition ? definition_2 : THROW_CCE();
        tmp$ret$13 = new Triple(tmp_16, tmp_17, (translator_3 == null ? true : isInterface(translator_3, ContextTranslator)) ? translator_3 : THROW_CCE());
      }
      var tmp0_safe_receiver_0 = tmp$ret$13;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        var tmp$ret$14;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.b(tmp0_safe_receiver_0);
        tmp$ret$14 = Unit_getInstance();
      }
    }
    tmp$ret$15 = tmp0_mapNotNullTo;
    tmp$ret$16 = tmp$ret$15;
    return tmp$ret$16;
  };
  DITreeImpl.prototype.y4o = function (search) {
    var result = findBySpecs(this, search);
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(result, 10));
    var tmp0_iterator = result.d();
    while (tmp0_iterator.e()) {
      var item = tmp0_iterator.f();
      var tmp$ret$0;
      // Inline function 'org.kodein.di.internal.DITreeImpl.find.<anonymous>' call
      var key = item.k3();
      var translator = item.l3();
      tmp$ret$0 = new Triple(key, ensureNotNull(this.u4s_1.p(key)).r8_1, translator);
      tmp0_mapTo.b(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  DITreeImpl.prototype.z4o = function (key) {
    var tmp = this.u4s_1.p(key);
    return (tmp == null ? true : tmp instanceof Triple) ? tmp : THROW_CCE();
  };
  DITreeImpl.$metadata$ = classMeta('DITreeImpl', [DITree]);
  function Down(type) {
    TypeChecker.call(this);
    this.z4s_1 = type;
    this.a4t_1 = equals(this.z4s_1, Companion_getInstance().q4m_1);
  }
  Down.prototype.y4s = function (other) {
    return this.a4t_1 ? true : this.z4s_1.m4m(other);
  };
  Down.prototype.toString = function () {
    return 'Down(type=' + this.z4s_1 + ')';
  };
  Down.prototype.hashCode = function () {
    return hashCode(this.z4s_1);
  };
  Down.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Down))
      return false;
    var tmp0_other_with_cast = other instanceof Down ? other : THROW_CCE();
    if (!equals(this.z4s_1, tmp0_other_with_cast.z4s_1))
      return false;
    return true;
  };
  Down.$metadata$ = classMeta('Down', undefined, undefined, undefined, undefined, TypeChecker.prototype);
  function Up(type) {
    TypeChecker.call(this);
    this.b4t_1 = type;
  }
  Up.prototype.y4s = function (other) {
    return equals(other, Companion_getInstance().q4m_1) ? true : other.m4m(this.b4t_1);
  };
  Up.prototype.toString = function () {
    return 'Up(type=' + this.b4t_1 + ')';
  };
  Up.prototype.hashCode = function () {
    return hashCode(this.b4t_1);
  };
  Up.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Up))
      return false;
    var tmp0_other_with_cast = other instanceof Up ? other : THROW_CCE();
    if (!equals(this.b4t_1, tmp0_other_with_cast.b4t_1))
      return false;
    return true;
  };
  Up.$metadata$ = classMeta('Up', undefined, undefined, undefined, undefined, TypeChecker.prototype);
  function TypeChecker() {
  }
  TypeChecker.$metadata$ = classMeta('TypeChecker');
  function DirectDIBaseImpl(container, context) {
    this.c4t_1 = container;
    this.d4t_1 = context;
  }
  DirectDIBaseImpl.prototype.g4o = function () {
    return this.c4t_1;
  };
  DirectDIBaseImpl.prototype.b4p = function () {
    return this;
  };
  DirectDIBaseImpl.prototype.a4p = function () {
    var tmp = this.g4o();
    var tmp_0 = new DIImpl(tmp instanceof DIContainerImpl ? tmp : THROW_CCE());
    return On$default(tmp_0, this.d4t_1, null, 2, null);
  };
  DirectDIBaseImpl.prototype.h4p = function (context) {
    return new DirectDIImpl(this.g4o(), context);
  };
  DirectDIBaseImpl.prototype.i4p = function (type, tag) {
    var tmp = this.g4o();
    var tmp$ret$0;
    // Inline function 'org.kodein.di.internal.anyType' call
    var tmp0__get_anyType__cravgl = this.d4t_1;
    var tmp_0 = tmp0__get_anyType__cravgl.o6();
    tmp$ret$0 = isInterface(tmp_0, TypeToken) ? tmp_0 : THROW_CCE();
    var tmp_1 = new Key(tmp$ret$0, Companion_getInstance().p4m_1, type, tag);
    var tmp_2 = this.d4t_1.x();
    return tmp.q4o(tmp_1, tmp_2, 0, 4, null)();
  };
  DirectDIBaseImpl.$metadata$ = classMeta('DirectDIBaseImpl', [DirectDI]);
  function get_anyType_0(_this__u8e3s4) {
    var tmp = _this__u8e3s4.o6();
    return isInterface(tmp, TypeToken) ? tmp : THROW_CCE();
  }
  function synchronizedIfNull(lock, predicate, ifNotNull, ifNull) {
    var tmp0_safe_receiver = predicate();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return ifNotNull(tmp0_safe_receiver);
    }
    var tmp$ret$3;
    // Inline function 'org.kodein.di.internal.maySynchronized' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'org.kodein.di.internal.synchronizedIfNull.<anonymous>' call
      var tmp0_safe_receiver_0 = predicate();
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        var tmp$ret$2;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp$ret$1 = tmp0_safe_receiver_0;
        break $l$block;
      }
      return ifNull();
    }
    tmp$ret$3 = tmp$ret$1;
    var value = tmp$ret$3;
    return ifNotNull(value);
  }
  function synchronizedIfNotNull(lock, predicate, ifNull, ifNotNull) {
    if (predicate() == null) {
      return ifNull();
    }
    var tmp$ret$1;
    // Inline function 'org.kodein.di.internal.maySynchronized' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'org.kodein.di.internal.synchronizedIfNotNull.<anonymous>' call
      var tmp0_elvis_lhs = predicate();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = Unit_getInstance();
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var value = tmp;
      return ifNotNull(value);
    }
    tmp$ret$1 = tmp$ret$0;
    return ifNull();
  }
  function LazyDI(f) {
    this.e4t_1 = lazy(f);
  }
  LazyDI.prototype.f4t = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = baseDI$factory();
    tmp$ret$0 = this.e4t_1.x();
    return tmp$ret$0;
  };
  LazyDI.prototype.g4o = function () {
    return this.f4t().g4o();
  };
  LazyDI.prototype.bn = function (thisRef, property) {
    return this;
  };
  LazyDI.$metadata$ = classMeta('LazyDI', [DI]);
  function baseDI$factory() {
    return getPropertyCallableRef('baseDI', 1, KProperty1, function (receiver) {
      return receiver.f4t();
    }, null);
  }
  function DIProperty$provideDelegate$lambda($receiver, this$0, $prop) {
    return function () {
      var tmp;
      if (!($receiver == null) ? this$0.h4t_1 === get_AnyDIContext() : false) {
        var tmp_0 = Companion_getInstance_1();
        var tmp_1 = erasedOf($receiver);
        tmp = tmp_0.l4o(isInterface(tmp_1, TypeToken) ? tmp_1 : THROW_CCE(), $receiver);
      } else {
        tmp = this$0.h4t_1;
      }
      var context = tmp;
      return this$0.i4t_1(context, $prop.callableName);
    };
  }
  function DIProperty(trigger, originalContext, get) {
    this.g4t_1 = trigger;
    this.h4t_1 = originalContext;
    this.i4t_1 = get;
  }
  DIProperty.prototype.j4t = function () {
    return this.g4t_1;
  };
  DIProperty.prototype.k4t = function (receiver, prop) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = lazy(DIProperty$provideDelegate$lambda(receiver, this, prop));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.kodein.di.DIProperty.provideDelegate.<anonymous>' call
    var tmp0_safe_receiver = this.g4t_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l4t_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.b(tmp0_also);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  };
  DIProperty.$metadata$ = classMeta('DIProperty', [LazyDelegate]);
  function LazyDelegate() {
  }
  LazyDelegate.$metadata$ = interfaceMeta('LazyDelegate');
  function DirectDI() {
  }
  DirectDI.$metadata$ = interfaceMeta('DirectDI', [DirectDIBase]);
  function DirectDIImpl(container, context) {
    DirectDIBaseImpl.call(this, container, context);
  }
  DirectDIImpl.$metadata$ = classMeta('DirectDIImpl', [DirectDI], undefined, undefined, undefined, DirectDIBaseImpl.prototype);
  function newConcurrentMap() {
    return HashMap_init_$Create$();
  }
  function maySynchronized(lock, block) {
    return block();
  }
  function newLinkedList() {
    return ArrayList_init_$Create$();
  }
  //region block: post-declaration
  Singleton.prototype.p4n = get_argType;
  Singleton.prototype.i4n = get_description;
  Singleton.prototype.k4n = get_fullDescription;
  Singleton.prototype.p4p = get_supportSubTypes;
  Provider.prototype.p4n = get_argType;
  Provider.prototype.n4p = factoryFullName;
  Provider.prototype.l4n = get_scope;
  Provider.prototype.i4n = get_description;
  Provider.prototype.k4n = get_fullDescription;
  Provider.prototype.p4p = get_supportSubTypes;
  DIBuilderImpl.prototype.w4n = import$default;
  DIMainBuilderImpl.prototype.w4n = import$default;
  DIContainerImpl.prototype.s4o = factory$default;
  DIContainerImpl.prototype.t4o = provider;
  DIContainerImpl.prototype.q4o = provider$default;
  DIImpl.prototype.f4o = get_di;
  DIImpl.prototype.h4o = get_diContext;
  DIImpl.prototype.i4o = get_diTrigger;
  DITreeImpl.prototype.x4o = find$default;
  DirectDIBaseImpl.prototype.f4o = get_di_0;
  LazyDI.prototype.f4o = get_di;
  LazyDI.prototype.h4o = get_diContext;
  LazyDI.prototype.i4o = get_diTrigger;
  DirectDIImpl.prototype.f4o = get_di_0;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Module_init_$Create$;
  _.$_$.b = Companion_getInstance_0;
  _.$_$.c = Provider;
  _.$_$.d = Singleton;
  _.$_$.e = get_diContext;
  _.$_$.f = get_diTrigger;
  _.$_$.g = DIAware;
  _.$_$.h = Instance;
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./Kodein-Type-kodein-type-js-ir.js')));

